export enum Language {
  L_ALL = 0,
  /** L_ZH_CN - 简体 */
  L_ZH_CN = 1,
  /** L_ZH_HANT - 繁体 */
  L_ZH_HANT = 2,
  /** L_EN - 英文 */
  L_EN = 3,
  UNRECOGNIZED = -1,
}
export enum Currency {
  CU_UNKNOWN = 0,
  /** CU_CNY - 人民币 */
  CU_CNY = 1,
  /** CU_USD - 美元 */
  CU_USD = 2,
  /** CU_EUR - 欧元 */
  CU_EUR = 3,
  /** CU_JPY - 日元 */
  CU_JPY = 4,
  /** CU_KRW - 韩元 */
  CU_KRW = 5,
  /** CU_TWD - 新台币 */
  CU_TWD = 6,
  /** CU_HKD - 港币 */
  CU_HKD = 7,
  /** CU_SGD - 新加坡 */
  CU_SGD = 8,
  /** CU_AUD - 澳元 */
  CU_AUD = 9,
  /** CU_GBP - 英镑 */
  CU_GBP = 10,
  UNRECOGNIZED = -1,
}
export enum Country {
  CY_UNKNOWN = 0,
  /** CY_CHINA - 中国 */
  CY_CHINA = 1,
  /** CY_US - 美国 */
  CY_US = 2,
  /** CY_UK - 英国 */
  CY_UK = 3,
  /** CY_SINGAPORE - 新加坡 */
  CY_SINGAPORE = 4,
  /** CY_NZ - 新西兰 */
  CY_NZ = 5,
  /** CY_GERMANY - 德国 */
  CY_GERMANY = 6,
  /** CY_AUSTRALIA - 澳大利亚 */
  CY_AUSTRALIA = 7,
  /** CY_FRANCE - 法国 */
  CY_FRANCE = 8,
  /** CY_INDIA - 印度 */
  CY_INDIA = 9,
  /** CY_JAPAN - 日本 */
  CY_JAPAN = 10,
  UNRECOGNIZED = -1,
}
export enum UserSex {
  US_UNKNOWN = 0,
  /** US_MAN - 男性 */
  US_MAN = 1,
  /** US_WOMAN - 女性 */
  US_WOMAN = 2,
  UNRECOGNIZED = -1,
}
export enum TerminalHomeShowType {
  /** THST_UNKNOWN - 未知 */
  THST_UNKNOWN = 0,
  /** THST_LIST - 站点类别 */
  THST_LIST = 1,
  /** THST_MAP - 站点类别 */
  THST_MAP = 2,
  UNRECOGNIZED = -1,
}

export enum TerminalChannel {
  TC_UNKNOWN = 0,
  /** TC_APP - 运营APP */
  TC_APP = 1,
  /** TC_HOME_APP - 家充APP */
  TC_HOME_APP = 2,
  /** TC_WECHAT_MINI_APP - 微信小程序 */
  TC_WECHAT_MINI_APP = 10,
  /** TC_WECHAT_SERVICE - 微信服务号 */
  TC_WECHAT_SERVICE = 11,
  /** TC_ALI_MINI_APP - 支付宝小程序 */
  TC_ALI_MINI_APP = 20,
  /** TC_ALI_SERVICE - 支付宝服务号 */
  TC_ALI_SERVICE = 21,
  /** TC_EVSE - 设备 */
  TC_EVSE = 30,
  /** TC_H5 - 运营h5 */
  TC_H5 = 40,
  /** TC_HLHT - 互联互通 */
  TC_HLHT = 50,
  /** TC_BACKGROUND - 后台 */
  TC_BACKGROUND = 99,
  UNRECOGNIZED = -1,
}
/** 数据对象 */
export enum ADOType {
  /** ADOT_UNKNOWN - 全部对下, 根据前端交互来选择 */
  /** ADOT_OPERATOR - 运营商 */
  ADOT_OPERATOR = 1,
  /** ADOT_STATION - 站点 */
  ADOT_STATION = 2,
  /** ADOT_EVSE - 设备 */
  ADOT_EVSE = 4,
  /** ADOT_USER - 用户 */
  ADOT_USER = 8,
  /** ADOT_GROUP - 集团 */
  ADOT_GROUP = 16,
  /** ADOT_BRAND - 客户端品牌 */
  ADOT_BRAND = 32,
  /** ADOT_PROFIT_SHARING - 分账收款人 */
  ADOT_PROFIT_SHARING = 64,
  /** ADOT_CONNECTOR - 充电接口 */
  ADOT_CONNECTOR = 128,
  /** ADOT_CARD - 卡 */
  ADOT_CARD = 256,
  /** ADOT_VIN - VIN */
  ADOT_VIN = 512,
}

/** 用户订单状态筛选 */
export enum UserOrderStateFilter {
  /** UOSF_ALL - 所有 */
  UOSF_ALL = 0,
  /** UOSF_PROCESS - 进行中 */
  UOSF_PROCESS = 1,
  /** UOSF_UNPAID - 待支付 */
  UOSF_UNPAID = 2,
  /** UOSF_FINISH - 已完成 - 已关闭 */
  UOSF_FINISH = 3,
  /** UOSF_PREPARE - 待处理 - 待支付，待退款，待结算 */
  UOSF_PREPARE = 4,
  /** UOSF_ABNORMAL - 待处理 - 异常, 可疑单 */
  UOSF_ABNORMAL = 5,
  UOSF_OCCUPY = 10,
  UNRECOGNIZED = -1,
}

export enum TicketState {
  /** TICS_NEW - 新建 */
  TICS_NEW = 0,
  /** TICS_PENDING - 待处理 */
  TICS_PENDING = 10,
  /** TICS_PROCESS - 处理中 */
  TICS_PROCESS = 30,
  /** TICS_HANGUP - 挂起 */
  TICS_HANGUP = 50,
  /** TICS_PROCESSED - 已经处理完成 */
  TICS_PROCESSED = 80,
  /** TICS_CLOSE - 关闭 */
  TICS_CLOSE = 100,
  UNRECOGNIZED = -1,
}
export enum TicketType {
  /** TICT_UNKNOWN - 未知 */
  TICT_UNKNOWN = 0,
  /** TICT_FEEDBACK - 意见与反馈 */
  TICT_FEEDBACK = 1,
  /** TICT_INSTALL - 安装工单 */
  TICT_INSTALL = 2,
  /** TICT_AFTERSALE - 售后工单 */
  TICT_AFTERSALE = 3,
  UNRECOGNIZED = -1,
}
export enum TicketSource {
  /** TISE_UNKNOWN - 未知 */
  TISE_UNKNOWN = 0,
  /** TISE_APP - APP */
  TISE_APP = 1,
  /** TISE_MINI_APP - 小程序 */
  TISE_MINI_APP = 2,
  /** TISE_DMS - 出厂工具 */
  TISE_DMS = 3,
  /** TISE_CMS - CMS */
  TISE_CMS = 4,
  UNRECOGNIZED = -1,
}

export enum SEnable {
  /** SE_ENABLE -  */
  SE_ENABLE = 0,
  /** SE_DISABLE -  */
  SE_DISABLE = 1,
  UNRECOGNIZED = -1,
}
export enum EvseStandard {
  ES_UNKNOWN = 0,
  /** ES_CHINESE - 国标 */
  ES_CHINESE = 1,
  /** ES_AMERICAN - 美标 */
  ES_AMERICAN = 2,
  /** ES_EUROPEAN - 欧标 */
  ES_EUROPEAN = 4,
  UNRECOGNIZED = -1,
}
export enum EvsePhase {
  EP_UNKNOWN = 0,
  /** EP_ONE - 单相 */
  EP_ONE = 1,
  /** EP_THREE - 三相 */
  EP_THREE = 3,
  UNRECOGNIZED = -1,
}
export enum EvseOperationType {
  EOT_UNKNOWN = 0,
  /** EOT_HOME - 家充设备 */
  EOT_HOME = 1,
  /** EOT_OPERATOR - 运营设备 */
  EOT_OPERATOR = 2,
  UNRECOGNIZED = -1,
}
export enum UseVehicleType {
  UVT_UNKNOWN = 0,
  UVT_CART = 1,
  UVT_BIKE = 2,
  UNRECOGNIZED = -1,
}
export enum EvseCurrentType {
  /** ECT_UNKNOWN -  */
  ECT_UNKNOWN = 0,
  /** ECT_AC - 交流 */
  ECT_AC = 1,
  /** ECT_DC - 直流 */
  ECT_DC = 2,
  /** ECT_AC_DC - 交直流一体机 */
  ECT_AC_DC = 3,
  UNRECOGNIZED = -1,
}
export enum EvseFunction {
  /** EF_SectionPirce - 支持分段计费 */
  EF_SectionPirce = 1,
  /** EF_ScheduleCharge - 定时充电 */
  EF_ScheduleCharge = 2,
  /** EF_GetTariff - 获取计费模版 */
  EF_GetTariff = 3,
  /** EF_ElecThreeDecimals - 3位小数计费 */
  EF_ElecThreeDecimals = 4,
  /** EF_ReserverCharge - 预约充电 */
  EF_ReserverCharge = 5,
  /** EF_OfflineCharge - 离线启动充电 */
  EF_OfflineCharge = 6,
  /** EF_SyncAli_0 - 需要同步阿里云 - 重模式 */
  EF_SyncAli_0 = 7,
  /** EF_SyncAli_1 - 需要同步阿里云 - 轻模式 */
  EF_SyncAli_1 = 8,
  /** EF_BT - 支持蓝牙 */
  EF_BT = 9,
  /** EF_BT_NO_SENSE - 支持蓝牙+无感 */
  EF_BT_NO_SENSE = 10,
  UNRECOGNIZED = -1,
}
export enum EvseNetworkingMode {
  /** ENM_UNKNOWN - 未知 */
  ENM_UNKNOWN = 0,
  /** ENM_WIFI - WIFI */
  ENM_WIFI = 1,
  /** ENM_4G - 4G */
  ENM_4G = 2,
  /** ENM_LAN - 网口 */
  ENM_LAN = 4,
  /** ENET_2_4G - 2.4G */
  ENET_2_4G = 8,
  /** ENET_5G - 5G */
  ENET_5G = 16,
  UNRECOGNIZED = -1,
}
export enum StartAuthState {
  /** SAS_OK - 鉴权成功； */
  SAS_OK = 0,
  /** SAS_BAN - 账户冻结； */
  SAS_BAN = 1,
  /** SAS_EXPIRED - 账户过期； */
  SAS_EXPIRED = 2,
  /** SAS_INVALID - 账户无效； */
  SAS_INVALID = 3,
  /** SAS_REPETITION - 有未结算的订单，不允许开启多笔订单； */
  SAS_REPETITION = 4,
  /** SAS_INSUFFICIENT - 余额不足； */
  SAS_INSUFFICIENT = 5,
  /** SAS_PASSWD_ERROR - 密码错误 */
  SAS_PASSWD_ERROR = 6,
  /** SAS_Other - other 其他错误 */
  SAS_Other = 10,
  UNRECOGNIZED = -1,
}

export enum InvoiceTitleType {
  ITT_UNKNOWN = 0,
  /** ITT_PERSON - 个人发票抬头 */
  ITT_PERSON = 1,
  /** ITT_COMPANY - 单位发票抬头 */
  ITT_COMPANY = 2,
  UNRECOGNIZED = -1,
}

/** 设备订单充电状态 整数表示正常状态, 其他的表示异常 */
export enum EvseOrderState {
  /** EOS_INIT - 初始下单 */
  EOS_INIT = 0,
  /** EOS_PENDING - 启动指令已下发，订单等待处理 */
  EOS_PENDING = 10,
  /** EOS_REMOTE_START_REJECT - 设备拒绝启动充电（马上退款） */
  EOS_REMOTE_START_REJECT = 11,
  /** EOS_REMOTE_START_TIMEOUT - 启动充电超时（马上退款） */
  EOS_REMOTE_START_TIMEOUT = 12,
  /**
     EOS_REMOTE_START_CONF_TIMEOUT -
     启动充电回复超时（原是马上退款，先修改成3天内退款）
   */
  EOS_REMOTE_START_CONF_TIMEOUT = 13,
  /** EOS_REMOTE_START_FAIL - 启动充电失败，后台导致的（马上退款） */
  EOS_REMOTE_START_FAIL = 14,
  /** EOS_RESERVER - 预约成功 */
  EOS_RESERVER = 20,
  /** EOS_RESERVER_EXPIRES - 预约过期 */
  EOS_RESERVER_EXPIRES = 21,
  /** EOS_RESERVER_CANCEL - 预约取消 */
  EOS_RESERVER_CANCEL = 22,
  /** EOS_REMOTE_STARTED - 启动充电成功，等待连接 */
  EOS_REMOTE_STARTED = 30,
  /** EOS_CONNECT_TIMEOUT - 连接超时（3天内退款） */
  EOS_CONNECT_TIMEOUT = 31,
  /** EOS_CONNECTOR_UNAVAILABLE_SUSPEND - 枪头不可用导致订单挂起 */
  EOS_CONNECTOR_UNAVAILABLE_SUSPEND = 32,
  /** EOS_CHARGING - 连接成功，充电中 */
  EOS_CHARGING = 50,
  /** EOS_CONNECTOR_DIFF_SESSION_SUSPEND - 枪头的订单会话不一致导致挂起 */
  EOS_CONNECTOR_DIFF_SESSION_SUSPEND = 51,
  /** EOS_CONNECTOR_AVAILABLE_SUSPEND - 枪头空闲可用导致订单挂起 */
  EOS_CONNECTOR_AVAILABLE_SUSPEND = 52,
  /** EOS_CONNECTOR_FAULT_SUSPEND - 枪头故障导致订单挂起 */
  EOS_CONNECTOR_FAULT_SUSPEND = 53,
  /** EOS_CONNECTOR_OFFLINE_SUSPEND - 枪头离线导致订单挂起 */
  EOS_CONNECTOR_OFFLINE_SUSPEND = 54,
  /** EOS_DEAD - 长时间不活跃，订单挂起 */
  EOS_DEAD = 55,
  /** EOS_REMOTE_STOPPED - Deprecated 废弃这两状态，没有必要 */
  EOS_REMOTE_STOPPED = 70,
  /** EOS_REMOTE_STOP_TIMEOUT - 结束充电超时 */
  EOS_REMOTE_STOP_TIMEOUT = 71,
  /** EOS_STOPPED - 结束充电成功，等待计费结果 */
  EOS_STOPPED = 90,
  /** EOS_COST_CONFLICT - 费用冲突 */
  EOS_COST_CONFLICT = 91,
  /** EOS_FINISH - 充电完成--- */
  EOS_FINISH = 100,
  UNRECOGNIZED = -1,
}

export enum KWHTariffTag {
  /** KWHTT_UNKNOWN - 未知 */
  KWHTT_UNKNOWN = 0,
  /** KWHTT_SHARP - 尖 */
  KWHTT_SHARP = 1,
  /** KWHTT_PEAK - 峰 */
  KWHTT_PEAK = 2,
  /** KWHTT_FLAT - 平 */
  KWHTT_FLAT = 3,
  /** KWHTT_VALLEY - 谷 */
  KWHTT_VALLEY = 4,
  /** KWHTT_DEEP_VALLEY - 深谷 */
  KWHTT_DEEP_VALLEY = 5,
  UNRECOGNIZED = -1,
}
export enum CarTariffType {
  /** CTT_UNKNOWN - 未知 */
  CTT_UNKNOWN = 0,
  /** CTT_KWH - 按电量 */
  CTT_KWH = 1,
  /** CTT_PLUGIN_TIME - 按插枪时间计费 */
  CTT_PLUGIN_TIME = 2,
  /** CTT_CHARGING_TIME - 按充电时间计费 */
  CTT_CHARGING_TIME = 3,
  UNRECOGNIZED = -1,
}
export enum OperationTerminalFunc {
  /** OTF_SHARE_EVSE - 分享设备 */
  OTF_SHARE_EVSE = 0,
  UNRECOGNIZED = -1,
}
export enum StationState {
  /** SS_UNKNOWN - 未知 */
  SS_UNKNOWN = 0,
  /** SS_IN_CONSTRUCTION - 1：建设中 */
  SS_IN_CONSTRUCTION = 1,
  /** SS_CLOSE - 5：关闭下线 */
  SS_CLOSE = 5,
  /** SS_MAINTAINED - 6：维护中 */
  SS_MAINTAINED = 6,
  /** SS_OPERATION - 50：正常使用 */
  SS_OPERATION = 50,
  UNRECOGNIZED = -1,
}

export enum StationConstruction {
  SC_ConstructionUNKNOWN = 0,
  /** SC_HousingEstate - 住宅区 */
  SC_HousingEstate = 1,
  /** SC_PublicInstitution - 公共区域 */
  SC_PublicInstitution = 2,
  /** SC_Enterprises - 企事业单位 */
  SC_Enterprises = 3,
  /** SC_OfficeBuilding - 写字楼 */
  SC_OfficeBuilding = 4,
  /** SC_IndustrialZone - 工业园区 */
  SC_IndustrialZone = 5,
  /** SC_TransportationHub - 交通枢纽 */
  SC_TransportationHub = 6,
  /** SC_RSFacilities - 大型文体设施 */
  SC_RSFacilities = 7,
  /** SC_UGSpace - 城市绿地 */
  SC_UGSpace = 8,
  /** SC_ParkingArea - 大型建筑配件停车场 */
  SC_ParkingArea = 9,
  /** SC_RoadsideParking - 路边停车位 */
  SC_RoadsideParking = 10,
  /** SC_HSServiceArea - 城际高速服务区 */
  SC_HSServiceArea = 11,
  /** SC_ScenicArea - 风景区 */
  SC_ScenicArea = 12,
  /** SC_BusStation - 公交场站 */
  SC_BusStation = 13,
  /** SC_OilGasStation - 加油加气站 */
  SC_OilGasStation = 14,
  /** SC_Taxi - 出租车 */
  SC_Taxi = 15,
  /** SC_Other - 其他 */
  SC_Other = 255,
  UNRECOGNIZED = -1,
}
export enum StationType {
  ST_UNKNOWN = 0,
  /** ST_PUBLIC - 1：公共 */
  ST_PUBLIC = 1,
  /** ST_PRIVATE - 50：个人 */
  ST_PRIVATE = 50,
  /** ST_BUS_ONLY - 100：公交（专用） */
  ST_BUS_ONLY = 100,
  /** ST_SANITATION_ONLY - 101：环卫（专用） */
  ST_SANITATION_ONLY = 101,
  /** ST_LOGISTICS_ONLY - 102：物流（专用） */
  ST_LOGISTICS_ONLY = 102,
  /** ST_TIXI_ONLY - 103：出租车（专用） */
  ST_TIXI_ONLY = 103,
  /** ST_DUMP_TRUCK_ONLY - 104：电动自卸车（专用） */
  ST_DUMP_TRUCK_ONLY = 104,
  /** ST_OTHER - 255：其他 */
  ST_OTHER = 255,
  UNRECOGNIZED = -1,
}
export enum EvseComponent {
  /** EC_EVSE_BASE - 设备基本信息，可不传 */
  EC_EVSE_BASE = 0,
  /** EC_EVSE_CONNECTOR - 设备枪头信息 */
  EC_EVSE_CONNECTOR = 1,
  /** EC_EVSE_MODEL - 设备型号信息 */
  EC_EVSE_MODEL = 2,
  /** EC_EVSE_ALARM_CNT - 设备告警计数 */
  EC_EVSE_ALARM_CNT = 3,
  /** EC_EVSE_ALARM_LIST - 设备告警列表 */
  EC_EVSE_ALARM_LIST = 4,
  UNRECOGNIZED = -1,
}
export enum ConnectorComponent {
  /** CC_BASE - 枪头基本信息， 可不传 */
  CC_BASE = 0,
  /** CC_EVSE - 设备信息 */
  CC_EVSE = 1,
  UNRECOGNIZED = -1,
}
/** 运营状态 */
export enum BusinessState {
  /** BS_INIT - 初始化状态 */
  BS_INIT = 0,
  /** BS_OPEN_BUSINESS - 开始运营 */
  BS_OPEN_BUSINESS = 1,
  /** BS_SUSPEND_BUSINESS - 暂停运营 */
  BS_SUSPEND_BUSINESS = 2,
  /** BS_CLOSED_BUSINESS - 停止运营 */
  BS_CLOSED_BUSINESS = 3,
  /** BS_INTERNAL_BUSINESS - 内部运营 */
  BS_INTERNAL_BUSINESS = 4,
  UNRECOGNIZED = -1,
}
export enum EvseChargingSpeedType {
  ECS_UNKNOWN = 0,
  ECS_SLOW = 1,
  ECS_FAST = 2,
  UNRECOGNIZED = -1,
}
export enum EvseConnectorType {
  ECT_UNRECOGNIZABLE = 0,
  /** ECT_AC_GBT - 交流GB/T 20234 */
  ECT_AC_GBT = 1,
  /** ECT_AC_TYPE1 - 交流SEA-J1772 */
  ECT_AC_TYPE1 = 2,
  /** ECT_AC_TYPE2 - 交流IEC62196 */
  ECT_AC_TYPE2 = 3,
  /**
     ECT_AC_TYPE1_TINY - 交流SEA-J1772 (日本)特有 额定电流电压比美国用的小
     插头也小些
   */
  ECT_AC_TYPE1_TINY = 4,
  /** ECT_AC_NACS - 交流NACS 特斯拉枪头 */
  ECT_AC_NACS = 5,
  /** ECT_DC_GBT - 直流GB/T 20234 */
  ECT_DC_GBT = 6,
  /** ECT_DC_CCS1 - 直流SEA-J1772 */
  ECT_DC_CCS1 = 7,
  /** ECT_DC_CCS2 - 直流IEC62196 */
  ECT_DC_CCS2 = 8,
  /** ECT_DC_CHM - 直流CHADEMO */
  ECT_DC_CHM = 9,
  /** ECT_DC_NACS - 直流NACS 特斯拉枪头 */
  ECT_DC_NACS = 10,
  ECT_BIKE = 11,
  UNRECOGNIZED = -1,
}
export enum EvseChargingStartMode {
  /** ECSM_UNKNOWN - 授权启动充电 */
  ECSM_UNKNOWN = 0,
  /** ECSM_AUTH_MODE - 授权启动充电 */
  ECSM_AUTH_MODE = 1,
  /** ECSM_PLUGIN_MODE - 即插即充模式 */
  ECSM_PLUGIN_MODE = 2,
  UNRECOGNIZED = -1,
}
export enum EvseState {
  /** EC_UNKNOWN - 未知 */
  EC_UNKNOWN = 0,
  /** ES_OFFLINE - 离线 */
  ES_OFFLINE = 1,
  /** ES_ONLINE - 在线 */
  ES_ONLINE = 2,
  /** ES_EXCEPTION - 故障 */
  ES_EXCEPTION = 3,
  /** ES_NONACTIVATED - 未激活 */
  ES_NONACTIVATED = 10,
  UNRECOGNIZED = -1,
}
export enum ConnectorState {
  /** CS_Unavailable - 不可用 */
  CS_Unavailable = 0,
  /** CS_Available - 空闲 */
  CS_Available = 1,
  /** CS_Preparing - 已连接，未开启充电会话 */
  CS_Preparing = 2,
  /** CS_Charging - 充电中 */
  CS_Charging = 3,
  /** CS_SuspendedEVSE - 充电已开启，但充电桩还未输出 */
  CS_SuspendedEVSE = 4,
  /** CS_SuspendedEV - 充电已开启，电动汽车还未充电 */
  CS_SuspendedEV = 5,
  /** CS_Finishing - 充电完成，还处于占用状态 */
  CS_Finishing = 6,
  /** CS_Reserved - 预约 */
  CS_Reserved = 7,
  /** CS_Faulted - 故障 */
  CS_Faulted = 8,
  /** CS_Waiting - 定时充电等待、轮充等待等 */
  CS_Waiting = 9,
  /** CS_Occupied - 设备占用中，不知道是什么状态 */
  CS_Occupied = 10,
  UNRECOGNIZED = -1,
}
/** EvseProtocolVendor 设备协议类型 */
export enum EvseProtocolVendor {
  EPV_UNKNOWN = 0,
  /** EPV_GOIOT - goiot协议 */
  EPV_GOIOT = 1,
  /** EPV_SINEXCEL - 盛泓协议 */
  EPV_SINEXCEL = 2,
  /** EPV_SZUNIT - 永联协议 */
  EPV_SZUNIT = 3,
  /** EPV_YKC - 云快充协议 */
  EPV_YKC = 4,
  /** EPV_HKC - 好快充协议 */
  EPV_HKC = 5,
  /** EPV_OCPP - OCPP协议 */
  EPV_OCPP = 6,
  /** EPV_BLUETOOTH - 蓝牙协议 */
  EPV_BLUETOOTH = 7,
  /** EPV_CD - 橙电协议 */
  EPV_CD = 8,
  /** EPV_QINGAN - 清安储能站 */
  EPV_QINGAN = 9,
  /** EPV_SUNGROW - 阳光储能站 */
  EPV_SUNGROW = 10,
  UNRECOGNIZED = -1,
}
export enum EvseDoorStatus {
  EDS_UNKNOWN = 0,
  /** EDS_OPEN - 开启 */
  EDS_OPEN = 1,
  /** EDS_CLOSED - 关闭 */
  EDS_CLOSED = 2,
  UNRECOGNIZED = -1,
}
export enum OTAStatus {
  /** FW_Idle - 未激活 */
  FW_Idle = 0,
  /** FW_Pending - 准备中 */
  FW_Pending = 1,
  /** FW_DownloadScheduled - 固件下载计划中 */
  FW_DownloadScheduled = 2,
  /** FW_Downloading - 固件下载中 */
  FW_Downloading = 3,
  /** FW_DownloadPaused - 固件暂停下载 */
  FW_DownloadPaused = 9,
  /** FW_Downloaded - 固件已下载 */
  FW_Downloaded = 10,
  /** FW_SignatureVerified - 固件通过签名验证 */
  FW_SignatureVerified = 11,
  /** FW_InstallScheduled - 固件安装计划中 */
  FW_InstallScheduled = 20,
  /** FW_Installing - 固件安装中 */
  FW_Installing = 22,
  /** FW_Installed - 固件安装成功 */
  FW_Installed = 25,
  /** FW_InstallRebooting - 固件重启中 */
  FW_InstallRebooting = 29,
  /** FW_DeliveryFail - 下发失败 */
  FW_DeliveryFail = 30,
  /** FW_DeliverySuccess - 下发成功 */
  FW_DeliverySuccess = 31,
  /** FW_OTASuccess - 升级成功 */
  FW_OTASuccess = 100,
  /** FW_InstallationFailed - 失败的情况 */
  FW_InstallationFailed = 9901,
  /** FW_InstallVerificationFailed - 固件验证失败 */
  FW_InstallVerificationFailed = 9902,
  /** FW_InvalidSignature - 固件验证签名失败 */
  FW_InvalidSignature = 9903,
  /** FW_DownloadFailed - 固件下载失败 */
  FW_DownloadFailed = 9904,
  UNRECOGNIZED = -1,
}
export enum OTAConfStatus {
  /**
     Accepted - Accepted this firmware update request. This does not mean the
     firmware update is successful, the Charging Station will now start the
     firmware update process.
   */
  Accepted = 0,
  /** Rejected - Firmware update request rejected. */
  Rejected = 1,
  /**
     AcceptedCanceled - Accepted this firmware update request, but in doing
     this has canceled an ongoing firmware update.
   */
  AcceptedCanceled = 2,
  /** InvalidCertificate - The certificate is invalid. */
  InvalidCertificate = 3,
  /**
     RevokedCertificate - Failure end state. The Firmware Signing certificate
     has been revoked.
   */
  RevokedCertificate = 4,
  UNRECOGNIZED = -1,
}
export enum EvseCtrlFunction {
  /** ECF_UNKNOWN - 未知 */
  ECF_UNKNOWN = 0,
  /** ECF_START_CHARGE - 启动充电， 需要带参数， 参数为枪头号 */
  ECF_START_CHARGE = 1,
  /** ECF_STOP_CHARGE - 停止充电， 需要带参数， 参数为枪头号 */
  ECF_STOP_CHARGE = 2,
  /** ECF_REBOOT - 重启设备 */
  ECF_REBOOT = 3,
  /** ECF_RESET - 回复出厂设置 */
  ECF_RESET = 4,
  /** ECF_CLEAR_CACHE - 清理缓存 */
  ECF_CLEAR_CACHE = 5,
  /** ECF_UNLOCK - 解锁枪头 */
  ECF_UNLOCK = 6,
  /** ECF_SET_MODE - 修改充电模式，需要带参数， 参数为 EvseChargingStartMode */
  ECF_SET_MODE = 7,
  UNRECOGNIZED = -1,
}
export enum SetConfigurationStatus {
  /** CFS_Accepted - 参数支持，已设置 */
  CFS_Accepted = 0,
  /** CFS_Rejected - 参数支持，但设置失败 */
  CFS_Rejected = 1,
  /** CFS_RebootRequired - 参数支持，已设置，但需要重启生效 */
  CFS_RebootRequired = 2,
  /** CFS_NotSupported - 参数不支持 */
  CFS_NotSupported = 3,
  UNRECOGNIZED = -1,
}
export enum EvseOccupyOrderState {
  /** EOOS_INIT - 初始化状态 */
  EOOS_INIT = 0,
  /** EOOS_OCCUPYING - 占庄中 */
  EOOS_OCCUPYING = 50,
  /** EOOS_FINISH - 占庄完成 */
  EOOS_FINISH = 100,
  UNRECOGNIZED = -1,
}
export enum ServiceMode {
  /** SM_AUTO_CHARGE - 自动充满模式 */
  SM_AUTO_CHARGE = 0,
  /** SM_CHARGE_BY_ELEC - 预设电量充电模式, 单独 千瓦.时 */
  SM_CHARGE_BY_ELEC = 1,
  /** SM_CHARGE_BY_TIME - 预设时间充电模式, 单位 分钟 */
  SM_CHARGE_BY_TIME = 2,
  /** SM_CHARGE_BY_MONEY - 预设金额充电模式, 单位 分 */
  SM_CHARGE_BY_MONEY = 3,
  /** SM_DISCHARGE_BY_ELEC - 按电量放电 */
  SM_DISCHARGE_BY_ELEC = 4,
  /** SM_AUTO_DISCHARGE - 自动放电 */
  SM_AUTO_DISCHARGE = 5,
  UNRECOGNIZED = -1,
}
export enum StopReason {
  /**
     SR_Normal - 按照服务类型（按电量充电，按时长充电，按金额充电,
     BMS正常结束等）正常停止充电。
   */
  SR_Normal = 0,
  /** SR_Local_Card - 用户本地刷卡停止充电 */
  SR_Local_Card = 1,
  /** SR_LocalPIN - 用户本地输入校验码停止充电 */
  SR_LocalPIN = 2,
  /** SR_RemoteUser - 用户远程结束 */
  SR_RemoteUser = 3,
  /** SR_RemoteAdmin - 管理员远程结束 */
  SR_RemoteAdmin = 4,
  /** SR_EmergencyStop - 急停按下，停止充电 */
  SR_EmergencyStop = 5,
  /** SR_EVDisconnected - 检测到枪头断开，停止充电 */
  SR_EVDisconnected = 6,
  /** SR_Reboot - 系统重启停止充电 */
  SR_Reboot = 7,
  /** SR_OffLine - 充电桩断线，停止充电（对于不允许离线充电的充电桩） */
  SR_OffLine = 8,
  /** SR_PowerLoss - 充电桩掉电，停止充电 */
  SR_PowerLoss = 9,
  /** SR_SystemFault - 充电桩故障，停止充电 */
  SR_SystemFault = 10,
  /** SR_BMSFault - 电动车故障，停止充电 */
  SR_BMSFault = 11,
  /** SR_Other - 其它原因，停止充电 */
  SR_Other = 12,
  /** SR_MeterFault - 电表故障 */
  SR_MeterFault = 13,
  /** SR_SocFull - soc充满停止 */
  SR_SocFull = 16,
  /** SR_NotEnoughMoney - 余额不足 */
  SR_NotEnoughMoney = 17,
  /** SR_OverLoad - 过载停止 */
  SR_OverLoad = 18,
  /** SR_OverVoltage - 过压停止 */
  SR_OverVoltage = 19,
  /** SR_UnderVoltage - 欠压停止 */
  SR_UnderVoltage = 20,
  /** SR_NetTimeout - 网络同步超时停止充电 */
  SR_NetTimeout = 21,
  /** SR_OverTime - 超过设置时间 */
  SR_OverTime = 22,
  /** SR_OverMeter - 超过设置电量 */
  SR_OverMeter = 23,
  /** SR_OverSOC - 超过设置SOC */
  SR_OverSOC = 24,
  /** SR_CPError - CP错误 */
  SR_CPError = 25,
  /** SR_Leakage - 漏电故障 */
  SR_Leakage = 26,
  /** SR_FullOfSelfStop - 100以内的停止理由留给我们自己的固件扩展 */
  SR_FullOfSelfStop = 101,
  /** SR_AdminForceStop - 管理员强制结束(原23) */
  SR_AdminForceStop = 102,
  /** SR_EVOccupy - 接口已被占用(原24) */
  SR_EVOccupy = 103,
  /** SR_NoTariff - 没有计费模版(原25) */
  SR_NoTariff = 104,
  /** SR_ConnectorFault - 充电枪故障(原26) */
  SR_ConnectorFault = 105,
  /**
     SR_CC1NoConnect - 充电枪未连接(充电中车辆控制引导异常/CC1连接异常)(原27)
   */
  SR_CC1NoConnect = 106,
  /** SR_Deauthorized - 取消授权 */
  SR_Deauthorized = 107,
  /** SR_EVConnectTimeout - 连接超时 */
  SR_EVConnectTimeout = 108,
  /** SR_Server_Error - 平台错误 */
  SR_Server_Error = 99999999,
  UNRECOGNIZED = -1,
}
export enum IdType {
  /** IT_UNKONWN - 未知 */
  IT_UNKONWN = 0,
  /** IT_LOCAL_PLUG - 本地即插即充启动 */
  IT_LOCAL_PLUG = 1,
  /** IT_LOCAL_ADMIN - 本地管理员启动 */
  IT_LOCAL_ADMIN = 2,
  /** IT_LOCAL_IDENTITY_CARD - 鉴权卡刷卡本地鉴权启动 */
  IT_LOCAL_IDENTITY_CARD = 3,
  /** IT_ONLINE_IDENTITY_CARD - 鉴权卡刷卡在线鉴权启动 */
  IT_ONLINE_IDENTITY_CARD = 4,
  /** IT_LOCAL_WALLET_CARD - 本地钱包卡刷卡启动 */
  IT_LOCAL_WALLET_CARD = 5,
  /** IT_LOCAL_VIN - 车辆VIN本地鉴权启动 */
  IT_LOCAL_VIN = 6,
  /** IT_ONLINE_VIN - 车辆VIN在线鉴权启动 */
  IT_ONLINE_VIN = 7,
  /** IT_BLUETOOTH - 本地通过蓝牙启动 */
  IT_BLUETOOTH = 8,
  /** IT_MAC - 本地通过输入校验码启动 */
  IT_MAC = 9,
  /** IT_REMOTE_ADMIN - 远程管理员启动 */
  IT_REMOTE_ADMIN = 10,
  /** IT_REMOTE_USER - 远程用户启动 */
  IT_REMOTE_USER = 11,
  /** IT_REMOTE_API - 远程API启动 */
  IT_REMOTE_API = 12,
  /** IT_CHARGING_PLANS - 充电计划 */
  IT_CHARGING_PLANS = 13,
  /** IT_NO_SENSE - 无感启动 */
  IT_NO_SENSE = 14,

  UNRECOGNIZED = -1,
}

export enum ExportOrderType {
  EXOT_UNKNOWN = 0,
  /** EXOT_CHARGING_ORDER - 订单筛选导出 */
  EXOT_CHARGING_ORDER = 1,
  /** EXOT_CHARGING_REPORT - 充电账单 */
  EXOT_CHARGING_REPORT = 2,
  /** EXOT_WALLET_REPORT - 钱包账单 */
  EXOT_WALLET_REPORT = 3,
  UNRECOGNIZED = -1,
}

/** 公共状态 */
export enum CommonState {
  /** CMS_UNKNOWN - 未知 */
  CMS_UNKNOWN = 0,
  /** CMS_PENDING - 待处理 */
  CMS_PENDING = 10,
  /** CMS_PROCESS - 处理中 */
  CMS_PROCESS = 20,
  /** CMS_FAIL - 处理失败 */
  CMS_FAIL = 50,
  /** CMS_PROCESSED - 处理成功 */
  CMS_PROCESSED = 80,
  /** CMS_CLOSE - 关闭 / 取消 */
  CMS_CLOSE = 100,
  UNRECOGNIZED = -1,
}
export enum CommonConfStatus {
  /** CCS_ACCEPTED - Accepted 的请求已接受，并将被执行。 */
  CCS_ACCEPTED = 0,
  /** CCS_REJECTED - Rejected 的请求尚未被接受，并且不会被执行。 */
  CCS_REJECTED = 1,
  /** CCS_NOTSUPPORTED - NotSupported 不支持的命令 */
  CCS_NOTSUPPORTED = 2,
  /** CCS_UNAVAILABLE - 不能使用 */
  CCS_UNAVAILABLE = 3,
  /** CCS_FAULTED - 失败 */
  CCS_FAULTED = 4,
  /** CCS_OCCUPIED - 占用 */
  CCS_OCCUPIED = 5,
  UNRECOGNIZED = -1,
}
export enum OrderOP {
  OP_UNKNOWN = 0,
  /** OP_CHARGER_WALLET_PAY - 充值单 */
  OP_CHARGER_WALLET_PAY = 1,
  /** OP_REFUND_WALLET_PAY - 退款单 */
  OP_REFUND_WALLET_PAY = 2,
  /** OP_CHARGING - 充电订单 */
  OP_CHARGING = 3,
  /** OP_OCCUPANCY_PAY - 占桩订单 */
  OP_OCCUPANCY_PAY = 4,
  /** OP_AGENCY_PAYMENT - 代理支付单 */
  OP_AGENCY_PAYMENT = 10,
  UNRECOGNIZED = -1,
}

/** 统计维度 */
export enum StatisticsTimeGrain {
  STD_UNKNOWN = 0,
  /** STD_HOUR - 小时 */
  STD_HOUR = 5,
  /** STD_DAY - 天 */
  STD_DAY = 10,
  /** STD_WEEK - 周 */
  STD_WEEK = 20,
  /** STD_MONTH - 月 */
  STD_MONTH = 30,
  /** STD_QUARTER - 季度 */
  STD_QUARTER = 35,
  /** STD_YEAR - 年 */
  STD_YEAR = 40,
  /** STD_TOTAL - 总计 */
  STD_TOTAL = 45,
  UNRECOGNIZED = -1,
}

export enum PaymentMethod {
  PM_UNKNOWN = 0,
  /** PM_PREPAYMENT - 先付费 */
  PM_PREPAYMENT = 1,
  /** PM_POSTPAYMENT - 后付费 */
  PM_POSTPAYMENT = 2,
  /** PM_FREE - 免费 */
  PM_FREE = 3,
  UNRECOGNIZED = -1,
}
export enum PaymentMode {
  /** PM_Unknown - 未知支付 */
  PM_Unknown = 0,
  /** PM_WECHAT_PAY - 微信支付 */
  PM_WECHAT_PAY = 1,
  /** PM_ALI_PAY - 支付宝支付 */
  PM_ALI_PAY = 2,
  /** PM_GROUP - 集团支付 */
  PM_GROUP = 3,
  /** PM_IDCARD - 鉴权卡 */
  PM_IDCARD = 4,
  /** PM_WALLET_CARD - 钱包卡 */
  PM_WALLET_CARD = 5,
  /** PM_USER_BALANCE - 用户余额 */
  PM_USER_BALANCE = 6,
  /** PM_MANUL - 后台 */
  PM_MANUL = 7,
  /** PM_VIN - VIN */
  PM_VIN = 8,
  /** PM_PAYPAL - paypal */
  PM_PAYPAL = 9,
  /** PM_STRIPE - stripe */
  PM_STRIPE = 10,
  /** PM_FREE - 免费(家充) */
  PM_FREE = 11,
  /** PM_TP - 第三方平台支付 */
  PM_TP = 12,

  UNRECOGNIZED = -1,
}
export enum PaymentChannel {
  PC_UNKNOWN = 0,
  /** PC_ALI_PAY - 支付宝 */
  PC_ALI_PAY = 1,
  /** PC_WECHAT_PAY - 微信 */
  PC_WECHAT_PAY = 10,
  /**
     PC_PAYMENT_HUB - 我们自己的支付中心, 具体怎么分发由支付中心配置说了算，
     这个是当外部业务调用时使用
   */
  PC_PAYMENT_HUB = 30,
  /** PC_DINPAY - 智付 分账第三方支付 */
  PC_DINPAY = 50,
  /** PC_HEEPAY - 汇园支付, 新低运营商支付 */
  PC_HEEPAY = 55,
  /** PC_YEEPAY - 易宝支付 分账第三方支付 */
  PC_YEEPAY = 60,
  /** PC_PAYPAL - paypal */
  PC_PAYPAL = 70,
  /** PC_STRIPE - stripe */
  PC_STRIPE = 80,
  UNRECOGNIZED = -1,
}
export enum PaymentChannelMerchantType {
  /** PCMT_MERCHANT - 商户模式, 1个渠道支持一个商户 */
  PCMT_MERCHANT = 0,
  /** PCMT_SAAS_SERVICE - 服务商模式, 1个渠道支持多个商户 */
  PCMT_SAAS_SERVICE = 1,
  UNRECOGNIZED = -1,
}
export enum OrderTransactState {
  /** OTS_UNKNOWN - 未知状态 */
  OTS_UNKNOWN = 0,
  /** OTS_INIT - 初始化状态(改成1,避免0值问题) */
  OTS_INIT = 1,
  /** OTS_PAY_PENDING - 待支付 */
  OTS_PAY_PENDING = 10,
  /** OTS_PAY_PROCESSING - 支付中 */
  OTS_PAY_PROCESSING = 20,
  /** OTS_PAY_SUCCESS - 支付成功 */
  OTS_PAY_SUCCESS = 30,
  /** OTS_PAY_FAIL - 支付失败 */
  OTS_PAY_FAIL = 40,
  /** OTS_REFUND_INIT - 待退款 */
  OTS_REFUND_INIT = 50,
  /** OTS_REFUNDING - 退款中 */
  OTS_REFUNDING = 60,
  /** OTS_REBATES - 部分退款 */
  OTS_REBATES = 70,
  /** OTS_REFUNDED - 全额退款 */
  OTS_REFUNDED = 80,
  /** OTS_CLOSE - 订单关闭, 订单异常，不产生订单金额 */
  OTS_CLOSE = 90,
  UNRECOGNIZED = -1,
}
export enum OrderState {
  /** OS_UNKNOWN - 未知状态 */
  OS_UNKNOWN = 0,
  /** OS_INIT - 业务初始化状态(改成1,避免0值问题) */
  OS_INIT = 1,
  /** OS_WAIT - 业务等待处理 */
  OS_WAIT = 10,
  /** OS_PROCESS - 业务处理中 */
  OS_PROCESS = 50,
  /** OS_ABNORMAL - 业务处于未知异常状态，等待进一步处理 */
  OS_ABNORMAL = 80,
  /** OS_CLOSE - 订单关闭, 订单异常，不产生订单金额 */
  OS_CLOSE = 90,
  /** OS_FINISH - 业务正常完成 */
  OS_FINISH = 100,
  UNRECOGNIZED = -1,
}
export enum OrderSettlementState {
  /** OSS_UNKNOWN - 未激活 */
  OSS_UNKNOWN = 0,
  /** OSS_INIT - 准备结算 */
  OSS_INIT = 1,
  /** OSS_PROCESS - 结算中 */
  OSS_PROCESS = 10,
  /** OSS_ABNORMAL - 结算未知异常 */
  OSS_ABNORMAL = 50,
  /** OSS_ABNORMAL_EXCESS - 结算异常状态，充超额了 */
  OSS_ABNORMAL_EXCESS = 51,
  /** OSS_ABNORMAL_BIZ_NON_FINISH_STATE - 业务不是处于完成状态，无法结算 */
  OSS_ABNORMAL_BIZ_NON_FINISH_STATE = 52,
  /** OSS_ABNORMAL_WALLET_LACK_MONEY - 钱包余额不足 */
  OSS_ABNORMAL_WALLET_LACK_MONEY = 53,
  /** OSS_SUCCESS - 业务正常完成 */
  OSS_SUCCESS = 100,
  UNRECOGNIZED = -1,
}
export enum TransactionState {
  /** TS_UNKNOWN - 未知状态 */
  TS_UNKNOWN = 0,
  /** TS_INIT - 初始化状态(改成1,避免0值问题) */
  TS_INIT = 1,
  /** TS_PENDING - 交易待处理 */
  TS_PENDING = 10,
  /**
     TS_HANGUP - 交易挂起（第三方对交易有疑问，挂起交易然后人工审核。
     这个状态很少，目前是在国外有遇到）
   */
  TS_HANGUP = 30,
  /** TS_PROCESSING - 交易处理中 */
  TS_PROCESSING = 50,
  /** TS_FAIL - 交易失败 */
  TS_FAIL = 70,
  /** TS_CLOSE - 交易关闭 */
  TS_CLOSE = 90,
  /** TS_SUCCESS - 交易成功 */
  TS_SUCCESS = 100,
  UNRECOGNIZED = -1,
}
export enum ProfitSharingTransactionType {
  /** PSTT_UNKNOWN - 未知状态 */
  PSTT_UNKNOWN = 0,
  /** PSTT_PROFIT_SHARING - 订单分账 */
  PSTT_PROFIT_SHARING = 1,
  /** PSTT_WITHDRAW - 提现 */
  PSTT_WITHDRAW = 2,
  /** PSTT_WITHDRAW_REVOCATION - 提现撤销 */
  PSTT_WITHDRAW_REVOCATION = 3,
  /** PSTT_TRADE_FEE - 交易手续费 */
  PSTT_TRADE_FEE = 4,
  /** PSTT_WITHDRAW_FEE - 提现手续费 */
  PSTT_WITHDRAW_FEE = 5,
  /** PSTT_WALLET_TRANSFER - 钱包之间转账 */
  PSTT_WALLET_TRANSFER = 6,
  /** PSTT_PROFIT_SHARING_REVOCATION - 分账撤销 */
  PSTT_PROFIT_SHARING_REVOCATION = 7,
  UNRECOGNIZED = -1,
}
export enum ProfitSharingTradeState {
  /** PSTS_UNKNOWN - 未知状态 */
  PSTS_UNKNOWN = 0,
  /** PSTS_NOT_RECORDED - 待入账 */
  PSTS_NOT_RECORDED = 1,
  /** PSTS_FAIL - 失败 */
  PSTS_FAIL = 80,
  /** PSTS_CLOSE - 关闭 */
  PSTS_CLOSE = 90,
  /** PSTS_FUNDS_RECORDED - 已入账 */
  PSTS_FUNDS_RECORDED = 100,
  UNRECOGNIZED = -1,
}
export enum StatisticsOrderStatus {
  SOS_UNKNOWN = 0,
  /** SOS_TOTAL_ORDER - 总订单金额 */
  SOS_TOTAL_ORDER = 1,
  /** SOS_TOTAL_ORDER_YESTERDAY - 总订单金额-昨天之前 */
  SOS_TOTAL_ORDER_YESTERDAY = 2,
  /** SOS_TOTAL_WALLEL - 总钱包余额 */
  SOS_TOTAL_WALLEL = 3,
  /** SOS_TOTAL_WITHDRAW - 总提现金额, 已经到客户账的金额 */
  SOS_TOTAL_WITHDRAW = 4,
  /** SOS_REQUEST_WITHDRAW - 提现中金额, 请求了第三方提现，还没有到账金额 */
  SOS_REQUEST_WITHDRAW = 5,
  /** SOS_PROFIT_AMOUNT - 总利润 */
  SOS_PROFIT_AMOUNT = 6,
  /** SOS_WITHDRAW_APPLY - 提现申请数量 */
  SOS_WITHDRAW_APPLY = 7,
  /** SOS_PROFILSHARING_NOT_RECORDED - 利润待入账金额 */
  SOS_PROFILSHARING_NOT_RECORDED = 8,
  /** SOS_BIZ_ORDER_PROCESS - 业务处理中 */
  SOS_BIZ_ORDER_PROCESS = 9,
  UNRECOGNIZED = -1,
}
export enum TransactionType {
  /** TT_UNKNOWN - 未知状态 */
  TT_UNKNOWN = 0,
  /** TS_PAY - 支付 */
  TS_PAY = 1,
  /** TS_REFUND - 退款 */
  TS_REFUND = 2,
  /** TS_RECHARGE - 充值 */
  TS_RECHARGE = 3,
  /** TS_WITHHOLD - 扣款 */
  TS_WITHHOLD = 4,
  UNRECOGNIZED = -1,
}
export enum ProfitSharingSource {
  /** PSS_UNKNOWN - 未知来源 */
  PSS_UNKNOWN = 0,
  /** PSS_ELECTRIC_AMOUNT - 电费 */
  PSS_ELECTRIC_AMOUNT = 1,
  /** PSS_SERVICE_AMOUNT - 服务费 */
  PSS_SERVICE_AMOUNT = 2,
  /** PSS_TOTAL_AMOUNT - 总费用 */
  PSS_TOTAL_AMOUNT = 3,
  UNRECOGNIZED = -1,
}
export enum ProfitSharingAccountType {
  /** PSAT_UNKNOWN - 未知来源 */
  PSAT_UNKNOWN = 0,
  /** PSAT_ENTERPRISE - 企业 */
  PSAT_ENTERPRISE = 1,
  /** PSAT_PRIVATE - 个人 */
  PSAT_PRIVATE = 2,
  /** PSAT_PRIVATE_ENTERPRISE - 个人工商户 */
  PSAT_PRIVATE_ENTERPRISE = 3,
  UNRECOGNIZED = -1,
}
export enum ProfitSharingBillState {
  /** PSBS_UNKNOWN - 未知状态 */
  PSBS_UNKNOWN = 0,
  /** PSBS_INIT -  */
  PSBS_INIT = 1,
  /** PSBS_PENDING - 交易待分账给客户 */
  PSBS_PENDING = 10,
  PSBS_PROCESS = 50,
  UNRECOGNIZED = -1,
}
export enum AuditState {
  /** CAS_UNKNOWN - 未知状态 */
  CAS_UNKNOWN = 0,
  /** CAS_INIT - 待处理 */
  CAS_INIT = 1,
  /** CAS_REJECTED - 拒绝 */
  CAS_REJECTED = 2,
  /** CAS_ACCEPTED - 同意 */
  CAS_ACCEPTED = 3,
  UNRECOGNIZED = -1,
}

export enum PaymentOrderInfoComponent {
  /** OIC_ALL - 未知状态 */
  OIC_ALL = 0,
  /** OIC_ORDER - 订单数据, 这个填不填都可以，默认输出 */
  OIC_ORDER = 1,
  /** OIC_TRANSACTION - 支付信息数据 */
  OIC_TRANSACTION = 2,
  /** OIC_PROFIT_SHARING_TRANSACTION - 分润数据 */
  OIC_PROFIT_SHARING_TRANSACTION = 3,
  /** OIC_PROFIT_SHARING_STRATEGY - 订单的分润策略信息 */
  OIC_PROFIT_SHARING_STRATEGY = 4,
  UNRECOGNIZED = -1,
}
export enum ProfitSharingStrategyBindFlagType {
  /** PSSBFT_UNKNOWN - 未知状态 */
  PSSBFT_UNKNOWN = 0,
  /** PSSBFT_OPERATOR - 运营商 */
  PSSBFT_OPERATOR = 1,
  /** PSSBFT_STATION - 站点 */
  PSSBFT_STATION = 2,
  UNRECOGNIZED = -1,
}
export enum BankCardType {
  /** BCT_DEBIT_CARD - 借记卡 */
  BCT_DEBIT_CARD = 0,
  /** BCT_CREDIT_CARD - 贷记卡 */
  BCT_CREDIT_CARD = 1,
  /** BCT_QUASI_CREDIT_CARD - 准贷卡 */
  BCT_QUASI_CREDIT_CARD = 2,
  /** BCT_PASSBOOK - 存折 */
  BCT_PASSBOOK = 3,
  /** BCT_UNIT_SETTLE_CARD - 单位结算卡 */
  BCT_UNIT_SETTLE_CARD = 4,
  /** BCT_PUBLIC_CARD - 对公卡 */
  BCT_PUBLIC_CARD = 5,
  UNRECOGNIZED = -1,
}
export enum PushState {
  /** PS_NOT - 不推送, app拉取 */
  PS_NOT = 0,
  /** PS_FAIL - 推送失败 */
  PS_FAIL = 50,
  /** PS_SUCCESS - 推送成功 */
  PS_SUCCESS = 100,
  UNRECOGNIZED = -1,
}
export enum SMSProvider {
  SMSP_ALI = 0,
  SMSP_WX = 1,
  UNRECOGNIZED = -1,
}
export enum NotiChannel {
  /** NC_UNKNOWN - 不推送, app拉取 */
  NC_UNKNOWN = 0,
  /** NC_MAIL - 邮件 */
  NC_MAIL = 1,
  /** NC_SMS - 短信 */
  NC_SMS = 2,
  /** NC_WX_MINIAPP - 微信小程序 */
  NC_WX_MINIAPP = 3,
  /** NC_WX_SERVICE - 微信服务号 */
  NC_WX_SERVICE = 4,
  /** NC_WX_COMPANY - 企业微信 */
  NC_WX_COMPANY = 5,
  /** NC_FEI_SHU - 飞书 */
  NC_FEI_SHU = 6,
  UNRECOGNIZED = -1,
}
export enum NotiType {
  STT_UNKNOWN = 0,
  /**
     STT_COMMON
     - {1}为您的{2}验证码，请于两分钟内填写。如非本人操作，请忽略本短信 //
     邮箱通知，查看邮箱模版
   */
  STT_COMMON = 1,
  /**
     STT_LOGIN
     - {1}为您的登录验证码，请于两分钟内填写。如非本人操作，请忽略本短信 //
     邮箱通知，查看邮箱模版
   */
  STT_LOGIN = 2,
  /**
     STT_WITHDRAW
     - {1}为您的提现验证码，请于两分钟内填写。如非本人操作，请忽略本短信 //
     邮箱通知，查看邮箱模版
   */
  STT_WITHDRAW = 3,
  /**
     STT_REGISTER
     - {1}为您的注册验证码，请于两分钟内填写。如非本人操作，请忽略本短信 //
     邮箱通知，查看邮箱模版
   */
  STT_REGISTER = 4,
  /** STT_FORGOT_PASSWD - 邮箱通知，查看邮箱模版 */
  STT_FORGOT_PASSWD = 5,
  /** STT_DELETE - 邮箱通知，查看邮箱模版 */
  STT_DELETE = 6,
  /** STT_ACCOUNT_INFO - 邮箱通知，查看邮箱模版 */
  STT_ACCOUNT_INFO = 7,
  /** STT_EVSE_ABNORMAL - 设备异常通知 */
  STT_EVSE_ABNORMAL = 30,
  /** STT_EVSE_START - 设备启动充电通知 */
  STT_EVSE_START = 31,
  /** STT_EVSE_STOP - 设备充电完成通知 */
  STT_EVSE_STOP = 32,
  /** STT_ORDER_CHARGING - 订单处于充电状态 */
  STT_ORDER_CHARGING = 50,
  /** STT_ORDER_FINISH - 订单完成 */
  STT_ORDER_FINISH = 51,
  /** STT_ORDER_ABNORMAL - 订单异常状态 */
  STT_ORDER_ABNORMAL = 53,
  UNRECOGNIZED = -1,
}
export enum AlarmLevelType {
  FN_UNKNOWN = 0,
  /** FN_COMMON - 普通 */
  FN_COMMON = 10,
  /** FN_MINOR - 次要 */
  FN_MINOR = 20,
  /** FN_IMPORTANT - 重要 */
  FN_IMPORTANT = 30,
  /** FN_CRASH - 紧急 */
  FN_CRASH = 40,
  UNRECOGNIZED = -1,
}
export enum AlarmState {
  AS_UNKNOWN = 0,
  /** AS_ACTION - 激活中 */
  AS_ACTION = 10,
  /** AS_CLOSE - 关闭 */
  AS_CLOSE = 100,
  UNRECOGNIZED = -1,
}
export enum AlarmType {
  AT_UNKNOWN = 0,
  /** AT_INTERVAL - 间隙故障 */
  AT_INTERVAL = 10,
  /** AT_BURST - 突变\信号故障 */
  AT_BURST = 20,
  /** AT_GRADUAL - 缓变故障 */
  AT_GRADUAL = 30,
  /** AT_COMPONENT - 元器件故障 */
  AT_COMPONENT = 40,
  UNRECOGNIZED = -1,
}
export enum AlarmRecoverType {
  ART_UNKNOWN = 0,
  /** ART_AUTO - 自动恢复 */
  ART_AUTO = 10,
  /** ART_MANUL - 人工恢复 */
  ART_MANUL = 20,
  /** ART_OPS - 运维恢复 */
  ART_OPS = 30,
  UNRECOGNIZED = -1,
}
export enum LoginType {
  /** LT_EMAIL - 0 邮箱登录 */
  LT_EMAIL = 0,
  /** LT_PHONE - 1 手机号登录 */
  LT_PHONE = 1,
  /** LT_APPLE - 2 appleid登录 */
  LT_APPLE = 2,
  /** LT_GOOGLE - 3 google登录 */
  LT_GOOGLE = 3,
  /** LT_WX - 4 小程序登陆 */
  LT_WX = 4,
  /** LT_ANONYMOUS - 5 匿名用户 */
  LT_ANONYMOUS = 5,
  UNRECOGNIZED = -1,
}
export enum FieldEnable {
  /** CES_UNKNOWN - 未知 */
  CES_UNKNOWN = 0,
  /** CES_ENABLE - 正常状态 */
  CES_ENABLE = 1,
  /** CES_DISABLE - 禁用状态 */
  CES_DISABLE = 2,
  UNRECOGNIZED = -1,
}
export enum UserStatus {
  /** CS_ENABLE - 启用 */
  CS_ENABLE = 0,
  /** CS_DISABLE - 禁用 */
  CS_DISABLE = 1,
  /** CS_LOGOFF - 注销 */
  CS_LOGOFF = 2,
  UNRECOGNIZED = -1,
}
export enum VerifyCodeType {
  VCT_UNKNOWN = 0,
  /** VCT_REGISTER - 注册 */
  VCT_REGISTER = 1,
  /** VCT_FORGOET_PASSWD - 忘记密码 */
  VCT_FORGOET_PASSWD = 2,
  UNRECOGNIZED = -1,
}
export enum UserWalletState {
  UWS_UNKNOWN = 0,
  /** UWS_NORMAL - 正常状态 */
  UWS_NORMAL = 1,
  /** UWS_CHARGING_LOCK - 充电锁定状态 */
  UWS_CHARGING_LOCK = 2,
  /** UWS_BAN - 禁用 */
  UWS_BAN = 3,
  UNRECOGNIZED = -1,
}
export enum EvseOrderInfoComponent {
  /** EOIC_BASE - 设备单基本信息 */
  EOIC_BASE = 0,
  /** EOIC_EVSE_ORDER_DETAIL - 设备订单分段信息详情 */
  EOIC_EVSE_ORDER_DETAIL = 1,
  /** EOIC_EVSE - 设备信息 */
  EOIC_EVSE = 2,
  /** EOIC_CONNECTOR - 枪头信息 */
  EOIC_CONNECTOR = 3,
  /** EOIC_PAYMENT_ORDER - 支付单信息 */
  EOIC_PAYMENT_ORDER = 4,
  UNRECOGNIZED = -1,
}
export enum HLHTPlatfrom {
  /** HP_C - 互联互通客户端，一般是运营商平台 */
  HP_C = 0,
  /** HP_S - 互联互通服务端，一般是市政平台，或者是引流平台 */
  HP_S = 1,
  UNRECOGNIZED = -1,
}
/** HLHTProtocol 互联互通协议 */
export enum HLHTProtocol {
  /** HP_HLHT - 互联互通-标准 */
  HP_HLHT = 0,
  /** HP_HLHTSZ - 互联互通-深圳 */
  HP_HLHTSZ = 1,
  /** HP_HLHTJX - 互联互通-江西监控 */
  HP_HLHTJX = 2,
  /** HP_AMAP - 互联互通-高德 */
  HP_AMAP = 3,
  /** HP_HLHTSH - 互联互通-上海监控(国网) */
  HP_HLHTSH = 4,
  /** HP_ALI - 互联互通-支付宝 */
  HP_ALI = 5,
  /** HP_JSOPEN - 捷顺道闸沟通 */
  HP_JSOPEN = 6,
  /** HP_BGC - 八桂充 */
  HP_BGC = 7,
  /** HP_ALIHOME - 支付宝家充 */
  HP_ALIHOME = 8,
  /** HP_ALIHLHT - 互联互通-支付宝 */
  HP_ALIHLHT = 9,
  // 路通云亭开放平台（道闸沟通）
  HP_LTY_OPEN = 10,
  // 内蒙古
  HP_NMG = 11,
  // 新电途
  HP_XDT = 12,

  UNRECOGNIZED = -1,
}
export enum HLHTFunc {
  HLHTF_UNKNOWN = 0,
  /** HLHTF_CHARGING_CTRL - 充电启停控制 */
  HLHTF_CHARGING_CTRL = 1,
  /** HLHTF_PUSH_ALL_ORDER - 推送所有订单，默认只推送自启动订单 */
  HLHTF_PUSH_ALL_ORDER = 2,
  UNRECOGNIZED = -1,
}
export enum HLHTEventType {
  HET_UNKNOWN = 0,
  /** HET_FILING - 1-备案 */
  HET_FILING = 1,
  /** HET_ACCEPTANCE - 2-验收 */
  HET_ACCEPTANCE = 2,
  /** HET_SECURITY_CHECK - 3-安全检查 */
  HET_SECURITY_CHECK = 3,
  /** HET_EQUIPMENT_VERIFICATION - 4-设备核查 */
  HET_EQUIPMENT_VERIFICATION = 4,
  /** HET_SELF_CHECK - 5-自查 */
  HET_SELF_CHECK = 5,
  /** HET_OTHER - 6-其他 */
  HET_OTHER = 6,
  /** HET_MAJOR_EVENT - 7-重大事件 */
  HET_MAJOR_EVENT = 7,
  UNRECOGNIZED = -1,
}
export enum HLHTEventCode {
  HEC_UNKNOWN = 0,
  /** HEC_OPERATOR_MATERIALS_SUBMITTED - 运营商材料已经提交 3 */
  HEC_OPERATOR_MATERIALS_SUBMITTED = 1001,
  /** HEC_EQUIPMENT_MATERIALS_SUBMITTED - 设备材料已经提交 3 */
  HEC_EQUIPMENT_MATERIALS_SUBMITTED = 1002,
  /** HEC_EQUIPMENT_ONLINE - 设备已经上线 3 */
  HEC_EQUIPMENT_ONLINE = 1003,
  /** HEC_EQUIPMENT_ACCEPTED - 设备已经验收 1 */
  HEC_EQUIPMENT_ACCEPTED = 2001,
  /** HEC_CHECK_TASK_CONF - 检查任务确定 2 */
  HEC_CHECK_TASK_CONF = 3001,
  /** HEC_SAFETY_MATERIALS_PREPARED - 安全自检材料已经准备 2 */
  HEC_SAFETY_MATERIALS_PREPARED = 3002,
  /** HEC_SAFETY_MATERIALS_SUBMITTED - 安全自检材料已经提交 2 */
  HEC_SAFETY_MATERIALS_SUBMITTED = 3003,
  /** HEC_STATION_INSPECTION_ADMISSION - 现场检查入场 2 */
  HEC_STATION_INSPECTION_ADMISSION = 3004,
  /** HEC_STATION_INSPECTION_COMPLETED - 现场检查完成 2 */
  HEC_STATION_INSPECTION_COMPLETED = 3005,
  /** HEC_STATION_SCORING_SUMMARY_COMPLETED - 现场评分总结完成 2 */
  HEC_STATION_SCORING_SUMMARY_COMPLETED = 3006,
  /**
     HEC_SAFETY_STATION_INSPECTION_COMPLETED - 安全自检现场检查结束-企业签字 2
   */
  HEC_SAFETY_STATION_INSPECTION_COMPLETED = 3007,
  /** HEC_GET_REPORT_APPROVED - 获得报告通过 2 */
  HEC_GET_REPORT_APPROVED = 3008,
  /** HEC_FAILED_TO_OBTAIN_REPORT - 获得报告不通过 2 */
  HEC_FAILED_TO_OBTAIN_REPORT = 3009,
  /** HEC_EQUIPMENT_DATA_SUBMITTED - 设备材料已经提交 2 */
  HEC_EQUIPMENT_DATA_SUBMITTED = 4001,
  /** HEC_VERIFICATION_CONTRACT - 核查合同中 2 */
  HEC_VERIFICATION_CONTRACT = 4002,
  /** HEC_VERIFY_CONTRACT_APPROVAL - 核查合同通过 2 */
  HEC_VERIFY_CONTRACT_APPROVAL = 4003,
  /** HEC_STATION_INSPECTION_BEGINS - 现场核查开始 2 */
  HEC_STATION_INSPECTION_BEGINS = 4004,
  /** HEC_STATION_INSPECTION_PASSED - 现场核查一次通过 2 */
  HEC_STATION_INSPECTION_PASSED = 4005,
  /** HEC_STATION_VERIFICATION_AGAIN - 现场核查二次核查中 2 */
  HEC_STATION_VERIFICATION_AGAIN = 4006,
  /** HEC_VERIFICATION_PASSED - 核查通过 2 */
  HEC_VERIFICATION_PASSED = 4007,
  /** HEC_VERIFICATION_FAILED - 核查不通过 1 */
  HEC_VERIFICATION_FAILED = 4008,
  /** HEC_SELF_CHECK_STARTS - 5001 自查启动 3 */
  HEC_SELF_CHECK_STARTS = 5001,
  /** HEC_SELF_CHECK_PASSED - 5002 自查通过 3 */
  HEC_SELF_CHECK_PASSED = 5002,
  /** HEC_SELF_CHECK_FAILED - 5003 自查不通过 3 */
  HEC_SELF_CHECK_FAILED = 5003,
  /** HEC_FIRE_EQUIPMENT_INSPECTION - 6001 消防设备检查 1 */
  HEC_FIRE_EQUIPMENT_INSPECTION = 6001,
  /** HEC_FIRE_EQUIPMENT_ACCEPTANCE_PASSED - 6002 消防设备验收通过 1 */
  HEC_FIRE_EQUIPMENT_ACCEPTANCE_PASSED = 6002,
  /** HEC_FIRE_EQUIPMENT_FAILURE - 6003 消防设备故障 1 */
  HEC_FIRE_EQUIPMENT_FAILURE = 6003,
  /** HEC_LAPTOP_FAILURE - 7001 配电故障 1 */
  HEC_LAPTOP_FAILURE = 7001,
  /** HEC_STATION_SERVICE_FAILURE - 7002 场站服务故障 1 */
  HEC_STATION_SERVICE_FAILURE = 7002,
  /** HEC_VEHICLE_BREAKDOWN - 7003 车辆故障 1 */
  HEC_VEHICLE_BREAKDOWN = 7003,
  UNRECOGNIZED = -1,
}
export enum CardSource {
  CS_UNKNOWN = 0,
  /** CS_EVSE - 设备自带 */
  CS_EVSE = 1,
  /** CS_OPERATOR - 运营商发卡 */
  CS_OPERATOR = 10,
  UNRECOGNIZED = -1,
}
export interface QuestionAndAnswer {
  id: number
  operatorId: number
  language: Language
  question: string
  answer: string
  images: string[]
  updatedAt: number
  createdAt: number
}
// export interface TicketMsg {}
export interface Ticket {
  /** 工单ID */
  id: number
  /** 运营ID */
  operatorID: number
  /** 用户ID */
  userID: number
  /** 用户姓名 */
  name: string
  /** 联系方式 */
  contact: string
  /** 内容 */
  content: string
  /** 图片 */
  images: string[]
  /** 类型 */
  type: TicketType
  /** 状态 */
  state: TicketState
  /** 来源 */
  source: TicketSource
  /** 处理人ID */
  processorID: number
  /** 处理人姓名 */
  processorName: string
  /** 处理人联系方式 */
  processorContact: string
  /** 备注 */
  remark: string
  updatedAt: number
  createdAt: number
}
export interface TicketProcessor {
  id: number
  name: string
  contact: string
  remark: string
  createdAt: number
  updatedAt: number
}
export interface ADO {
  adoType: ADOType
  id: number
  name: string
}
export interface ADOUse {
  ID: number
  OperatorID: number
  ADO: ADOType
  ADOID: number
  ADOName: string
  CreatedAt: number
}
export interface PageReq {
  /** 页码，从1开始 */
  page: number
  /** 每页显示数量, =0 表示只统计数量，不查询数据, < 0 返回全部数量 */
  limit: number
  /** 搜索 */
  search: string
  /** 授权ado筛选, 前端禁止传入 */
  ados: ADO[]
}
export interface PageReply {
  /** 总条数 */
  totalRows: number
}
export interface EvseUpgrade {
  /** 升级ID */
  id: number
  /** 设备ID */
  evseID: number
  /** 设备序列号 */
  sn: string
  /** 设备型号信息 */
  model: string
  /** 设备厂商 */
  vendor: string
  /** 设备产品 */
  product: string
  /** 运营商名称 */
  operatorName: string
  /** 运营商ID */
  operatorID: number
  /** 站点名称 */
  stationName: string
  /** 站点ID */
  stationID: number
  /** 当前版本 */
  currentVersion: string
  /** 要升级到的版本 */
  toVersion: string
  /** 升级下发状态 */
  status: OTAStatus
  /** 设备状态 */
  state: EvseState
  /** 备注 */
  remark: string
  /** 更新时间 */
  updatedAt: number
  /** 创建时间 */
  createdAt: number
}
export interface FirmwareUpgrade {
  /** 固件ID */
  ID: number
  /** 运营商ID */
  operatorID: number
  /** 型号ID */
  modelID: number
  /** 型号 */
  pn: string
  vendor: string
  product: string
  /** 要升级到的固件版本 */
  version: string
  /** 要升级到的固件版本号 */
  versionCode: number
  /** 升级地址 */
  upgradeUrl: string
  /** 备注 */
  remark: string
  /** 更新时间 */
  updatedAt: number
  /** 创建时间 */
  createdAt: number
}
export interface CarTariff {
  /** 分段费率开始时间，每半个小时一个单位。 取值[0 - 47] */
  timeStart: number
  /** 分段费率结束时间，每半个小时一个单位。 取值[1 - 48] */
  timeEnd: number
  /** 分段标签，比如"尖"，"峰"，"平"，"谷" */
  tag: KWHTariffTag
  /** 收费计量标准 */
  tariffType: CarTariffType
  /** 收费计量标准费用，分辨率0.1分 */
  price: number
  /** 收费计量标准收取小费，分辨率 0.1分 */
  servicePrice: number
}
export interface DayTariff {
  tariffs: CarTariff[]
}
export interface WeekTariff {
  /** 周一 到 周日 顺序传递 */
  tariffs: DayTariff[]
}
export interface CarPrice {
  /** 每天计费模版 */
  dayTariff: DayTariff | undefined
  /** 每周计费模版 */
  weekTariff: WeekTariff | undefined
}
export interface BikePrice {
  /** 按时长充电费用 */
  tariffs: BikeTariff[]
}
export interface BikeTariff {
  /** 分段费率起始功率，分辨率W */
  powerStart: number
  /** 分段费率结束功率，分辨率W */
  powerEnd: number
  /** 按小时服务费价格，分辨率RMB 0.1分。 */
  price: number
  /** 最小计费单位 0.1分。 */
  unitPrice: number
  /** 免费充电时间 */
  freeTime: number
}
export interface OccupyTariff {
  /** 免费时间 */
  freeTime: number
  /** 最高/封顶费用，分辨率RMB 0.1分 */
  maxFee: number
  /** 每分钟的费用，分辨率RMB 0.1分 */
  price: number
}

export interface PriceingInfo {
  priceing: Priceing | undefined
  operator: ADO | undefined
  uses: ADO[]
  /** 策略创建时间 */
  createdAt: number
}

export interface Priceing {
  /** 计价策略id */
  id: number
  /** 计价策略版本 */
  ver: number
  /** 名称 */
  name: string
  /** 描述 */
  desc: string
  /** 策略使用车辆 */
  vt: UseVehicleType
  /** 按电量计费 */
  elecTariffs: ElecTariff[]
  /** 按照时间功率计费 */
  chargingTimeTariffs: ChargingTimeTariff[]
  /** 占桩费 */
  occupyTariff: OccupyTariff | undefined
  /** 货币 */
  currency: Currency
  /** 策略版本创建时间 */
  createdAt: number
  /** 最小计费单位, 元 最多精确到4位小数。 */
  unitPrice: number
  /** 免费充电时间 */
  freeTime: number
}

/** 按照电量收费 */
export interface ElecTariff {
  /** 分段费率开始时间，每半个小时一个单位。 取值[0 - 47] */
  timeStart: number
  /** 分段费率结束时间，每半个小时一个单位。 取值[1 - 48] */
  timeEnd: number
  /** 分段标签，比如"尖"，"峰"，"平"，"谷" */
  tag: KWHTariffTag
  /** 电费，元 最多精确到4位小数 */
  price: number
  /** 服务费，元 最多精确到4位小数 */
  servicePrice: number
}

export interface Cost {
  /** 计费模版明细id, 对应 price_ver_id */
  tariffId: number
  /** 计费总电量 单位: KW.h */
  totalElectric: number
  /** 充电总费用 元 */
  totalAmount: number
  /** 总电费 元 */
  totalElecAmount: number
  /** 总服务费 元 */
  totalServiceAmount: number
  /** 费用明细 */
  details: CostBill[]
  /**
   * 费用冲突，一般用于核算费用，核算分段计费与总消费不一致的情况，如果一致则此字段为默认值0
   */
  conflictTotalCost: number
}
export interface CostBill {
  /** 分段标签，比如"尖"，"峰"，"平"，"谷" */
  tag: KWHTariffTag
  /** 分段费率开始时间, 时间戳 */
  timeStart: number
  /** 分段费率结束时间, 时间戳 */
  timeEnd: number
  /** 电费单价 单位 元 */
  elecPrice: number
  /** 电费单价 单位 元 */
  servicePrice: number
  /** 该分段所消耗电量  KW.h */
  electric: number
  /** 该分段所消费电量电费, 元 */
  electricCost: number
  /** 该分段所消费服务费, 元 */
  serviceCost: number
}

export enum ActivityState {
  /** ADS_UNKNOWN - 预留 */
  ADS_UNKNOWN = 0,
  /** ADS_NOT_STARTED - 未开始 */
  ADS_NOT_STARTED = 1,
  /** ADS_IN_ACTION - 活动中 */
  ADS_IN_ACTION = 2,
  /** ADS_CLOSE - 已经结束 */
  ADS_CLOSE = 3,
  UNRECOGNIZED = -1,
}

export enum ActivityType {
  /** AT_RESERVED - 预留 */
  AT_RESERVED = 0,
  /** AT_RECHARGER_GIFT - 充值赠送 ActivityItem.Val = 赠送金额 */
  AT_RECHARGER_GIFT = 1,
  /** AT_FULL_DISCOUNT - 满减 ActivityItem.Val = 满减金额 */
  AT_FULL_DISCOUNT = 2,
  /** AT_REBATE_DISCOUNT - 折扣 ActivityItem.Val = 折扣金额 */
  AT_REBATE_DISCOUNT = 3,
  UNRECOGNIZED = -1,
}

export interface ActivityTmplItem {
  /** 金额 */
  amount: number
  /** 值，根据 ActivityType 决定 */
  val: number
}

export enum AmountType {
  /** AT_OTHER -  */
  AT_OTHER = 0,
  /** AT_ELECTRIC_AMOUNT - 电费 */
  AT_ELECTRIC_AMOUNT = 1,
  /** AT_SERVICE_AMOUNT - 服务费 */
  AT_SERVICE_AMOUNT = 2,
  /** AT_TOTAL_AMOUNT - 总费用 */
  AT_TOTAL_AMOUNT = 3,
  UNRECOGNIZED = -1,
}

export interface ActivityTmpl {
  amountType: AmountType
  items: ActivityTmplItem[]
}

/** Activity 活动主体表 */
export interface Activity {
  /** 活动id */
  id: number
  /** 运营商id */
  operatorId: number
  /** 运营商Name */
  operatorName: string
  /** 活动名称 */
  name: string
  /** 活动描述 */
  description: string
  /** 活动创建人 */
  opManagerId: number
  /** 开始时间 */
  beginTime: number
  /** 结束时间(想长期活动就填一个时间比较大的值) */
  endTime: number
  /** 是否关闭 */
  isOpen: boolean
  /** 活动类型 */
  type: ActivityType
  /** 活动状态 // 1 未开始, 2 活动中, 3 活动结束, */
  state: ActivityState
  /** 活动内容 */
  tmpl: ActivityTmpl | undefined
  /** 创建 */
  createdAt: number
  /** 更新 */
  updatedAt: number
}
export interface KV {
  k: string
  v: string
}
export interface KVNum {
  k: string
  v: number
}
export interface EvseModel {
  /** 设备型号ID */
  id: number
  /** 所属运营商 */
  operatorID: number
  /** 所属运营商 */
  operatorName: string
  /** 设备厂商 */
  vendor: string
  /** 型号 */
  model: string
  /** 产品系列 */
  Product: string
  /** 设备标准 */
  standard: EvseStandard
  /** 相 */
  phase: EvsePhase
  /** 额定电压 (单位: V) */
  ratedVoltage: number
  /** 额定功率 (单位: W) */
  ratedPower: number
  /** 最小电流 (单位: A) */
  ratedCurrentMin: number
  /** 最小电流 (单位: A) */
  ratedCurrentMax: number
  /** 使用车型 */
  useVehicleType: UseVehicleType
  /** 设备电流类型(交/直流) */
  evseCurrentType: EvseCurrentType
  /** 联网方式 */
  networking: EvseNetworkingMode
}
export interface TerminalConfig {
  channel: TerminalChannel
  /** app配置 */
  latestVersionName: string
  /** 最新版本. 1000 */
  latestVersionCode: number
  /** 是否强制升级 */
  forceUpgrade: boolean
  /** ios客户端ID, apple登录校验时使用 */
  appleClientId: string
  /** google客户端ID,  google登录校验时使用 */
  googleClientId: string
  /** 小程序配置 */
  appid: string
  /** app密钥 */
  secret: string
  /** 不需要手机号， 默认需要 */
  NotNeedPhone: boolean
}
export interface OperationTerminal {
  id: number
  name: string
  operatorID: number
  /** 运营商 */
  operatorName: string
  /** 描述 */
  desc: string
  /** 各种服务号/小程序配置 */
  configs: TerminalConfig[]
  /** 功能标签 */
  funcs: OperationTerminalFunc[]
  /** 更新时间 */
  updatedAt: number
  /** 创建时间 */
  createdAt: number
}
export interface Operator {
  /** 运营商ID */
  id: number
  /** 运营名称 */
  name: string
  /** 运营代码 */
  code: string
  /** 联系电话 */
  tel: string
  /** 是否屏蔽 */
  isBlock: boolean
  /** 是否自我运营 */
  isSelfOperating: boolean
  /** 商户公司名称 */
  company: string
  /** 公司税号 */
  tfn: string
  /** 商户logo */
  logoUrl: string
  /** 商户公司地址 */
  address: string
  /** 国家 */
  country: Country
  /** 语言 */
  language: Language
  /** 货币 */
  currency: Currency
  /** 更新时间 */
  updatedAt: number
  /** 创建时间 */
  createdAt: number
  /** 联系邮箱 */
  email: string
  /** 运营状态 */
  businessState: BusinessState
  /** 联系人名称 */
  contacts: string
  /**  */
  remark: string
  areaCode: string
  lng: number
  lat: number
}
export interface Station {
  /** 站点ID (修改时必须) */
  id: number
  /** 站点名称 */
  name: string
  /** 运营商ID */
  operatorID: number
  /** 运营商名称 */
  operatorName: string
  /** 行政区域编码 */
  areaCode: string
  /** 地址 */
  address: string
  /** 经度 */
  lng: number
  /** 维度 */
  lat: number
  /** 封面图片 */
  coverURL: string
  /** 联系人 */
  contactName: string
  /** 联系人电话 */
  contactPhone: string
  /** 联系人邮箱 */
  contactEmail: string
  /** 站点状态 */
  state: StationState
  /** 站点类型 */
  type: StationType
  /** 营业状态 */
  businessState: BusinessState
  /** 营业时间描述 */
  businessDesc: string
  /** 是否对外开放 */
  isOpen: boolean
  /** 停车收费信息 */
  parkInfo: string
  /** 停车收费信息 */
  createdAt: number
  /** 充电接口数量, 用于显示 */
  evseNum: number
}

export enum StationTag {
  /** ST_GroundParking - 地面停车场 */
  ST_GroundParking = 0,
  /** ST_UnderGroundParking - 地下停车场 */
  ST_UnderGroundParking = 1,
  /** ST_FreeParking - 免费停车 */
  ST_FreeParking = 2,
  /** ST_FreeParkingTimeLimit - 限时免停 */
  ST_FreeParkingTimeLimit = 3,
  UNRECOGNIZED = -1,
}

// 支付方式类型
export enum PaymentModeType {
  PMT_UNKNOWN = 0,
  /** PMT_WALLET - 钱包支付 */
  PMT_WALLET = 1,
  /** PMT_ONLINE - 即冲即退 */
  PMT_ONLINE = 2,
  UNRECOGNIZED = -1,
}

export interface Evse {
  /** ID */
  id: number
  /** 运营商ID */
  operatorID: number
  /** 运营商名称 */
  operatorName: string
  /** 所属站点ID */
  stationID: number
  /** 所属站点名称 */
  stationName: string
  /** 序列号 */
  sn: string
  /** 设备名称 */
  name: string
  /** 是否是运营中的设备 */
  isOperating: boolean
  /** 设备运营类型 */
  evseOperationType: EvseOperationType
  /** 充电模式 */
  charingMode: EvseChargingStartMode
  /** 信号 */
  rssi: number
  /** sim卡识别号 */
  iccid: string
  /** mac地址，一般是蓝牙使用 */
  mac: string
  /** 枪头数量 */
  connectorNumber: number
  /** 空闲枪头数量 */
  availableConnectorNumber: number
  /** 状态 */
  state: EvseState
  /** 协议厂家 */
  protocolVendor: EvseProtocolVendor
  /** 固件版本号 */
  firmwareVersion: string
  /** 通讯版本号 */
  protocolVersion: string
  /** 电流限制, 有序充电时使用. 单位 A */
  currentLimit: number
  /** 是否屏蔽 */
  banned: boolean
  /** 最后一次保活时间 */
  lastActivityTime: number
  /** 上次链接断开原因 */
  lastDisconnectReason: string
  /** 设备型号ID */
  modelId: number
  /** 功能开关 */
  functions: EvseFunction[]
  /** 充电速度类型 快充或慢充 */
  chargingSpeedType: EvseChargingSpeedType
  /** 枪头类型 */
  connectorType: EvseConnectorType
  /** 设备型号信息 */
  evseModel: EvseModel | undefined
  connector: Connector[]
  /** 固件版本号 */
  firmwareVersionCode: number
  /** 创建时间 */
  createdAt: number
  /** 更新时间 */
  updatedAt: number
  /** 接入IP */
  accessIP: string
  /** 设备激活时间 */
  activityTime: number
  /** 最后一次登录时间 */
  lastBootTime: number
  /** 告警信息 */
  alarmInfo: EvseAlarmInfo | undefined
  /** 设备生产日期 */
  productionAt: number
}
export interface Connector {
  /** ID */
  id: number
  /** 设备ID */
  evseId: number
  /** 枪头编号 */
  connectorNo: number
  /** 枪头描述/枪头别名， 模式[sn-cno] */
  desc: string
  /** 上次设置计费模板的ID，如果一样，就不再下发计费模板命令了 */
  lastPriceId: number
  /** 枪当前状态 */
  state: ConnectorState
  /** 平台生成的设备订单号 */
  orderId: number
  /** 设备上送的订单号 */
  recordId: string
  /** 功率, 单位:W */
  power: number
  /** A相电流, 单位:A */
  currentA: number
  /** B相电流, 单位:A */
  currentB: number
  /** C相电流, 单位:A */
  currentC: number
  /** A相电压, 单位:V */
  voltageA: number
  /** B相电压, 单位:V */
  voltageB: number
  /** C相电压, 单位:V */
  voltageC: number
  /** 温度, 单位: ℃ */
  temperature: number
  /** 故障代码 */
  faultedCode: string
  /** 设备信息 */
  evse: Evse | undefined
  /** 故障描述 */
  faultedDesc: string
  /** 开始充电时间 */
  startChargingTime: number
  /** 故障解决方式 */
  faultedSolution: string
}
export interface ConnectorStatistics {
  /** 状态 */
  state: ConnectorState
  /** 数量 */
  num: number
}
export interface EvseOrderStatistics {
  /** 时间 */
  time: string
  /** 总订单数据 */
  totalOrderNum: number
  /** 总电量 度 */
  totalElec: number
  /** 总费用 元 */
  totalAmount: number
  /** 总电费 元 */
  totalElecAmount: number
  /** 总服务费 元 */
  totalServiceAmount: number
  /** 启动成功的订单数 */
  totalChargingOrder: number
  /** 总充电时间 秒 */
  totalChargingTime: number
}
export interface IdToken {
  /** 令牌类型 */
  idType: IdType
  /** Id的卡号 */
  id: string
  /** 余额 */
  balance: number
}
export interface StatisticsUnit {
  tag: string
  val: number
}
export interface PaymentMethodInfo {
  /** 支付类型 */
  pm: PaymentMode
  /** 支付配置信息 */
  param: { [key: string]: string }
}
export interface PaymentMethodInfo_ParamEntry {
  key: string
  value: string
}
export interface PaypalPaymentsInfo {
  /** Paypal客户端ID(收款对象) */
  clientID: string
  /** 第三方平台交易ID */
  paypalTradeID: string
  /** 环境 sandbox/live */
  env: string
}
export interface MiniappPaymentsInfo {
  /** 小程序appid */
  appid: string
  /** 时间戳 */
  timestamp: number
  nonceStr: string
  package: string
  signType: string
  paySign: string
}
export interface StatisticsOrderInfo {
  count: number
  amount: number
  time: string
}
export interface Order {
  /** 平台的订单ID */
  id: number
  /** 运营商ID */
  operatorId: number
  /** 站点ID */
  stationId: number
  /** 业务平台支付订单号 */
  outOrderId: string
  /** 业务平台业务订单号 */
  bizOrderId: number
  /** 客户ID */
  userId: number
  /** 支付操作 */
  paymentOp: OrderOP
  /** 下单终端 */
  paymentEndpoint: TerminalChannel
  /** 付款方式 */
  paymentMethod: PaymentMethod
  /** 支付渠道 */
  paymentChannel: PaymentChannel
  /** 支付渠道ID (默认支付渠道ID) */
  paymentChannelId: number
  /** 支付金额 */
  paymentAmount: number
  /** 退款金额 */
  refundAmount: number
  /** 实际支付金额 */
  paidAmount: number
  /** 应收金额 */
  receivableAmount: number
  /** 优惠金额 */
  discountAmount: number
  /** 最终收费 */
  final: number
  /** 订单支付状态 */
  paymentState: OrderTransactState
  /** 支付成功的流水ID */
  paymentTid: number
  /** 订单状态 */
  orderState: OrderState
  /** 是否需要分账 */
  isProfitSharing: boolean
  /** 分账策略ID */
  profitSharingId: number
  /** 分账策略版本 */
  profitSharingVerId: number
  /** 需要分账的金额, 剩下的是本金 */
  profitSharingAmount: number
  /** 是否已结算 */
  isSettlement: boolean
  /** 结算时间 */
  settlementTime: number
  /** 订单附加数据 */
  attach: string
  /** 订单描述 */
  desc: string
  /** 订单过期时间 */
  expireAt: number
  /** 下单终端IP */
  clientIp: string
  /** 订单创建时间 */
  createdAt: number
  /** 订单更新时间 */
  updatedAt: number
  /** 付款类型 */
  paymentMode: PaymentMode
}
export interface Transaction {
  /** 流水ID */
  id: number
  /** 运营商ID */
  operatorId: number
  /** 用户信息 */
  userId: number
  /** 订单ID 订单中心ID */
  orderId: number
  /** 交易类型 */
  transactionType: TransactionType
  /** 业务方订单号 */
  outOrderId: string
  /** 业务方支付单号 */
  outPayOrderId: string
  /** 业务方退款单号(退款幂等性保证) */
  outRefundOrderId: string
  /** 第三方支付公司 交易ID */
  ecpssTradeId: string
  /** 交易额 */
  amount: number
  /** 下单终端 */
  paymentTerminal: TerminalChannel
  /** 支付渠道 */
  paymentChannel: PaymentChannel
  /** 支付渠道ID */
  paymentChannelId: number
  /** 交易状态 */
  state: TransactionState
  /** 交易时间 */
  tradeTime: number
  /** 业务放回调地址 */
  notifyUrl: string
  /** 是否回调成功 */
  isNotified: boolean
  /** 备注(一般用于工作人员记录一些信息) */
  remark: string
  createdAt: number
  updatedAt: number
}
export interface ProfitSharingTransaction {
  /** 流水ID */
  id: number
  /** 运营商ID */
  operatorId: number
  /** 钱包ID */
  walletId: number
  /** 交易类型 */
  tradeType: ProfitSharingTransactionType
  /** 订单ID */
  orderId: number
  /** 业务订单ID/第三方订单号 */
  bizOrderId: string
  /** 交易金额 */
  tradeAmount: number
  /** 交易比例 */
  percentage: number
  /** 手续费 */
  fee: number
  /** 最终交易金额 = 交易金额 * 交易比例 - 手续费 */
  final: number
  /** 分账后wallet金额 */
  afterAmount: number
  /** 交易状态 */
  state: ProfitSharingTradeState
  /** 备注 */
  remark: string
  createdAt: number
  updatedAt: number
}
export interface ProfitSharingStrategyBindInfo {
  id: number
  strategyId: number
  bindFlagType: ProfitSharingStrategyBindFlagType
  bindFlagId: number
  isEnable: boolean
  isBind: boolean
  updatedAt: number
  createdAt: number
}
export interface ProfitSharingPercentage {
  payeeId: number
  /** 分账人姓名，返回时使用 */
  payeeName: number
  /** 分账比例， ower 不需要配置 */
  percentage: number
  /** 分账人备注信息 */
  remark: string
}
export interface ProfitSharingStrategy {
  /** 修改时必须 */
  id: number
  /** 站点主人 */
  ower: ProfitSharingPercentage | undefined
  /** 分账来源 电费or服务费or总费用 */
  source: ProfitSharingSource
  /** 分账人 */
  payees: ProfitSharingPercentage[]
  /** 策略改动版本 */
  version: number
  /** 是否启动分账 */
  enable: boolean
  /** 时间信息 */
  updatedAt: number
  /** 时间信息 */
  createdAt: number
  /** 整个分账的备注信息 */
  remark: string
}
export interface PaymentOrderInfo {
  order: Order | undefined
  transactions: Transaction[]
  profitSharingTransactions: ProfitSharingTransaction[]
  strategy: ProfitSharingStrategy | undefined
}
export interface WithdrawOrder {
  id: number
  operatorId: number
  walletId: number
  userId: number
  payeeName: string
  payeeCardNo: string
  walletBalance: number
  withdrawAmount: number
  state: AuditState
  tradeId: number
  withdrawReqState: TransactionState
  withdrawNote: string
  remark: string
  updatedAt: number
  createdAt: number
  trade: ProfitSharingTransaction | undefined
}
export interface Wallet {
  id: number
  operatorId: number
  userId: number
  payeeName: string
  payeeCardNo: string
  balance: number
  updatedAt: number
  createdAt: number
}
export interface ProfitSharingPayee {
  /** 收款方id 选填	添加时为空，修改时必填 */
  payeeId: number
  operatorId: number
  /** 收款方性质 收款方性质：0：企业 1：个人 2：个体工商户 */
  payeeType: string
  /** 收款方名称 收款方名称，企业、个体工商户传营业执照上的名称，个人传姓名 */
  payeeName: string
  /** 统一社会信用代码 收款方性质为企业和个体工商户时必传 */
  license: string
  /** 法人姓名 法人姓名 */
  corporation: string
  /** 证件类型 证件类型01:身份证 */
  certType: string
  /** 证件号码 证件号码(RSA-S加密传输,使用加密业务的公钥签名) */
  certNo: string
  /** 预留手机号 个体工商户和个人传结算卡银行预留手机号 */
  contactsMobile: string
  /**
   * 手持证件照 手持身份证或手持银行卡照片
   * 企业选填，个体和个人性质商户：预留手机号和手持身份证或手持银行卡照片二选一
   * 传入上传图片接口中智付返回的媒体文件标识Id
   */
  handheldIdcardPic: string
  /** 账户类型 账户类型：1企业；0个人 */
  accountType: string
  /** 户名 收款方为个人时，户名要与法人姓名一致。 */
  bankCardName: string
  /** 银行卡号 银行卡号(RSA-S加密传输,使用加密业务的公钥签名) */
  bankCard: string
  /** 银行code 银行code（请参考附录-银行编码_支行联行号_省市区编码.xlsx） */
  bankCode: string
  /**
   * 支行联行号 支行联行号(账户类型为企业必传)
   * （请参考附录-银行编码_支行联行号_省市区编码.xlsx）
   */
  uniteBankId: string
  /**
   * 省份ID
   * 支行联行号不为空时必填，填写支行所在省份编号（请参考附录-银行编码_支行联行号_省市区编码.xlsx）
   */
  proviceId: string
  /**
   * 城市ID
   * 支行联行号不为空时必填，填写支行所在城市编号（请参考附录-银行编码_支行联行号_省市区编码.xlsx）
   */
  cityId: string
  /**
   * 营业执照图片
   * 商家性质为企业和个体工商户时必传传入上传图片接口中智付返回的媒体文件标识Id
   */
  licensePic: string
  /** 法人身份证正面 	传入上传图片接口中智付返回的媒体文件标识Id */
  idcardPositivePic: string
  /** 法人身份证反面 	传入上传图片接口中智付返回的媒体文件标识Id */
  idcardNegativePic: string
  /**
   * 结算账户证明
   * 对公账户传开户许可证/基本存款账户信息照片，对私账户传银行卡正面照片（多张以竖线分割
   * 例如 aaaa|bbbb|cccc）
   */
  pictureInfo: string
  /** 合作协议 	传入上传图片接口中智付返回的媒体文件标识Id */
  contractInfo: string
  /** 卡类型 */
  bankCardType: BankCardType
  /** 是否是系统利润进件， 一个运营商只有一个 */
  isAdminProfit: boolean
}
export interface PaymentChannelAuth {
  id: number
  operatorId: number
  paymentChannel: PaymentChannel
  paymentChannelId: number
  paymentChannelName: string
  isDefault: boolean
  createdAt: number
  updatedAt: number
}
// export interface UserPaymentMethod {}
export interface ChargerOrderAmount {
  /** 总费用 单位分 */
  totalAmount: number
  /** 电量费用 单位分 */
  elecAmount: number
  /** 服务费用 单位分 */
  serviceAmount: number
  /** 优惠费用 单位分 */
  discountAmount: number
}
export interface Alarm {
  id: number
  /** 运营商ID */
  operatorID: number
  /** 设备ID */
  evseID: number
  /** 设备编号 */
  sn: string
  /** 枪编号 */
  cno: number
  /** 告警码 */
  code: string
  /** 告警描述 */
  desc: string
  /**  */
  type: AlarmType
  /** 告警级别 */
  level: AlarmLevelType
  /** 状态 */
  state: AlarmState
  /** 恢复类型 */
  recover: AlarmRecoverType
  /**  */
  createdAt: number
  /**  */
  closeAt: number
  /**  */
  operatorName: string
  /**  */
  remark: string
  /**  */
  logLevel: string
  /**  */
  solution: string
}
export interface EvseAlarmInfo {
  /** 总数量 */
  totalNum: number
  /** 活跃告警数量 */
  actNum: number
  /** 告警数量 */
  alarms: Alarm[]
}
export interface AlarmRepository {
  /** ID */
  id: number
  /** 运营商ID */
  operatorId: number
  /** 协议 */
  protocol: EvseProtocolVendor
  /** 告警类型 */
  type: AlarmType
  /** 告警级别 */
  level: AlarmLevelType
  /** 告警码 */
  alarmCode: string
  /** 告警名称 */
  alarmName: string
  /** 告警日志级别 */
  alarmLogLevel: string
  /** 解决方案 */
  solution: string
  /** 创建时间 */
  cratedAt: number
  /** 备注 */
  remark: string
}
export interface NotiMsg {
  id: number
  title: string
  content: string
  createdAt: number
  updatedAt: number
  /** 推送渠道, 0 不推送, 用户拉取 */
  pushChannel: NotiChannel
  /** 推送状态 */
  state: PushState
  /** 失败原因 */
  reason: string
  /** 是否已经阅读 */
  isRead: boolean
}
export interface Noti {
  id: number
  /** 品牌终端ID, 唯一的 */
  brandTerminalId: number
  /** 运营商 */
  operatorId: number
  /** 运营商 */
  operatorName: string
  /** 品牌名称 */
  brandName: string
  channels: NotiChannel[]
}
export interface MailConfig {
  /** 配置名称, 配置后外部可以直接使用这个配置名称发送邮件 */
  brandTerminalId: number
  /** 发送服务器服务器. e.g.: smtp.exmail.qq.com */
  sendHost: string
  /** 发送服务器服务器端口. e.g.: 465 */
  sendPort: number
  /** 发送授权账号. 一般是邮箱账号 */
  userName: string
  /** 发送授权账号密码. 一般是邮箱密码 */
  password: string
  /** 默认发送邮件 */
  defSenderMail: string
}
export interface MailMessage {
  /** 发件人邮件，可以为空。当为空时，将采用默认邮箱发送 */
  from: string
  /** 收件邮箱 */
  tos: string[]
  /** 抄送 */
  cc: string[]
  /** 主题 */
  subject: string
  /** 内容 */
  content: string
}
export interface SMSConfig {
  /** 配置名称, 配置后外部可以直接使用这个配置名称发送邮件 */
  brandTerminalId: number
  /** 腾讯云账户密钥对secretId */
  secretId: string
  /** 腾讯云账户密钥对secretKey。 */
  secretKey: string
  /** 腾讯后台，添加应用后生成的实际SdkAppId */
  appId: string
  /** 短信签名内容 */
  signName: string
  /** 短信模版 */
  tmpls: SMSTmpl[]
}
export interface SMSTmpl {
  notiType: NotiType
  id: string
}
export interface PaymentChannelAmounts {
  /** 账户余额 */
  balanceAmount: number
  /** 待结算金额 */
  frozenAmount: number
  /** 商户资金账户金额 */
  fundAmount: number
  /** 营销账户金额 */
  marketAmount: number
  /** 待分账账户金额 */
  divideAmount: number
  /** 手续费账户金额 */
  feeAmount: number
}
export interface PaymentConfigBase {
  /** 支付渠道是否支持分账 */
  supportProfitSharing: boolean
  /** 支付渠道是否开启分账 */
  enableProfitSharing: boolean
  /** 支付渠道是否支持代付 */
  supportAnotherPay: boolean
  /** 支付渠道是否开启代付 */
  enableAnotherPay: boolean
}
export interface PaymentConfigDinpay {
  /**
   * merchant_code	平台商ID	String(10)	必选
   * 商户签约时，智付支付平台分配的唯一商家号,举例：1111110106。
   */
  merchantCode: string
  /**
   * sub_merchant_code	子商户ID	String(10)	必选
   * 商户签约时，智付支付平台分配的唯一商家号。
   */
  subMerchantCode: string
  payPrivateKey: string
  payPublicKey: string
  transferPrivateKey: string
  transferPublicKey: string
  encrypePrivateKey: string
  encrypePulicKey: string
  transferUrl: string
  transferQueryUrl: string
  uploadImgUrl: string
  payeeApplyUrl: string
  payeeApplyQueryUrl: string
  queryBalanceUrl: string
  placeOrderUrl: string
  queryOrderUrl: string
  refundOrderUrl: string
  queryRefundOrderUrl: string
}
export interface PaymentConfigHeepay {
  mchUid: string
  appid: string
  key: string
}
export interface PaymentConfigYeepay {
  /** 易宝开发后台的appID */
  appid: string
  /** 平台商号 */
  parentMerchantNo: string
  /** 子商户号 */
  merchantCode: string
  /** 支付私钥 der格式 */
  payPrivateKey: string
  /** 支付公钥 der格式 */
  payPublicKey: string
}
export interface PaymentConfigPaypal {
  account: string
  clientId: string
  clientSecret: string
  apiBase: string
  /** live/sendbox */
  env: string
}
export interface UserWallet {
  /** id 自增， 为兼容家充用户，需要从0开始自增，因为家充协议要求是8位数 */
  ID: number
  /** 运营商ID */
  operatorID: number
  /** 总余额 */
  balance: number
  /** 本金 */
  principal: number
  /** 赠送 */
  gift: number
  /** 钱包状态 */
  states: UserWalletState[]
}
export interface User {
  /** id 自增， 为兼容家充用户，需要从0开始自增，因为家充协议要求是8位数 */
  ID: number
  /** 运营商信息 */
  operatorID: number
  /** 账号名称 */
  account: string
  /** 手机号 */
  phone: string
  /** 邮箱 */
  email: string
  /** 用户昵称 */
  nickName: string
  /** 用户图像 */
  imageUrl: string
  /** 出生日期 */
  birthday: number
  /** 性别 */
  sex: UserSex
  /** 身份证 */
  idcard: string
  /** 国家 */
  country: Country
  /** 地区编码 */
  arescode: string
  /** 邮政编码 */
  postcode: string
  /** 地址 */
  address: string
  /** 用户状态 */
  status: UserStatus
  /** 时区 */
  zone: string
  /** 备注 */
  remark: string
  /** 未注销用户，是否注销, 注销为空 */
  notLogoff: boolean
  /** 注册时间 */
  createdAt: number
  /** 更新时间 */
  updatedAt: number
  /** 运营商信息 */
  operatorName: string
  /** 钱包余额 */
  wallet: number
  /** 钱包赠送 */
  walletGift: number
  /** 来源 */
  source: TerminalChannel
}
export interface OrderSimple {
  /** 订单类型 */
  op: OrderOP
  /** 订单ID */
  orderId: number
  /** 站点ID */
  stationId: number
  /** 站点名称 */
  stationName: string
  /** 设备ID */
  evseId: number
  /** 设备名称 */
  evseName: string
  /** 充电量 */
  elec: number
  /** 订单金额 */
  amount: number
  /** 订单开始时间，时间戳 */
  startTime: number
  /** 订单结束时间， 时间戳 */
  stopTime: number
  /** 订单状态 */
  state: EvseOrderState
  /** 支付状态 */
  paymentState: OrderTransactState
}
export interface OrderInfo {
  /** 设备订单信息 */
  evseOrder: EvseOrder | undefined
  /** 支付单信息 */
  paymentOrder: Order | undefined
  /** 设备信息 */
  evse: Evse | undefined
  user: User | undefined
}
export interface EvseOrder {
  /** ID */
  ID: number
  /** 设备ID */
  evseID: number
  /** 枪头ID */
  connectorID: number
  /**
   * 客户ID，重要：刷卡不写入customer_id（不做限制充电），VIN以及远程启动充电需要写入customer_id，远程启动充电以及vin充电时不能有充电中的订单
   */
  userID: number
  /** 硬件充电流水号, 这个流水号，可以是平台下发，也可以是设备自动生成 */
  recordID: string
  /** 订单类型 */
  orderType: EvseOperationType
  /** 订单状态 */
  state: EvseOrderState
  /** 授权启动方式 */
  authorizationMode: IdType
  /** 授权的ID，如果是remote发起的，则是userID;如果是刷卡，则是cardID(平台ID) */
  authorizationID: string
  /** 充电服务模式 */
  serviceMode: ServiceMode
  /** 充电服务模式对应的值 */
  serviceValue: number
  /** 启动时的电量 单位 KW.h */
  startElectricity: number
  /** 结束时的电量 单位 KW.h */
  stopElectricity: number
  /** 开始时间 */
  chargeStartTime: number
  /** 结束时间 */
  chargeStopTime: number
  /** 计费模板ID */
  tariffId: number
  /** 启动SOC */
  startSoc: number
  /** 结束SOC */
  stopSoc: number
  /** 停止原因 */
  stopReason: StopReason
  /** 停止原因描述 */
  stopReasonDesc: string
  /** 创建时间 */
  createdAt: number
  /** 更新时间 */
  updateAt: number
  /** 费用信息 */
  cost: Cost | undefined
  /**  */
  stationId: number
  /**  */
  stationName: string
  /**  */
  operatorId: number
  /**  */
  operatorName: string
  /** 充电总电量 单位 KW.h */
  totalElectricity: number
}
export interface HLHTSecret {
  /**
   * 注1：平台标识（OperatorID）：固定 9
   * 位，运营商的统一社会信用代码中组织机构代码，作为运营商的唯一标示；
   */
  OperatorID: string
  /**
   * 注2：平台密钥（OperatorSecret）：可采用 16H、32H、48H 和 64H，由 0-F
   * 字符组成，为申请认证使用；
   */
  OperatorSecret: string
  /** 注3：消息密钥（DataSecret）：用于对所有接口中 Data 信息进行加密； */
  DataSecret: string
  /**
   * 注4：消息密钥初始化向量（DataSecretIV）：固定 16 位，用户 AES
   * 加密过程的混合加密；
   */
  DataSecretIV: string
  /**
   * 注5：签名密钥（SigSecret）：可采用 32H、48H 和 64H，由 0-F
   * 字符组成，为签名的加密密钥。
   */
  SigSecret: string
  /** URL */
  URL: string
}
export interface HLHTConfig {
  /** ID */
  ID: number
  /** 运营商ID */
  OperatorID: number
  /** 配置名称 */
  Name: string
  /** 描述 */
  Desc: string
  /** 我们平台是互联互通的角色 */
  SeflPlatfromType: HLHTPlatfrom
  /** 客户端配置 */
  CSecret: HLHTSecret | undefined
  /** 服务端配置 */
  SSecret: HLHTSecret | undefined
  /** 客户端Token */
  CToken: string
  /** 服务端Token */
  SToken: string
  /** 服务端Token过期时间, 0/nil 表示不过期 */
  STokenExpireAt: number
  /** 客户端Token过期时间, 0/nil 表示不过期 */
  CTokenExpireAt: number
  /** 功能支持 */
  Funcs: HLHTFunc[]
}
export interface ChargingReserverSchedule {
  /** 预约标志 空标识单次， 1-7， 表示周一到周天 */
  repeat: number[]
  /** 开始时间 重复的表示每天的第几秒；单次表 示时间戳 */
  startTime: number
  /** 充电时间 充电时长，分钟 */
  chargeTime: number
  /** 电流 A */
  current: number
  /**
   * 结束时间, 非必须字段，给前端展示使用. 重复的表示每天的第几秒；单次表
   * 示时间戳
   */
  stopTime: number
}
export interface ChargingSchedulePeriod {
  /** Limit 限制 */
  limit: number
  /** NumberPhases 充电相数 */
  numberPhases: number
  /** StartPeriod 开始时间 */
  startPeriod: number
}
export interface ChargingSchedule {
  /**
   * ChargingRateUnit 充电速率单位, 包括A、W等。W 通常用于直流, A
   * 通常用于交流。必填
   */
  chargingRateUnit: string
  /**
   * ChargingSchedulePeriod 充电计划的周期列表。必填
   *      每个周期包含了一段时间内的充电速率设置，包括起始时间、持续时间和充电速率。通过使用ChargingSchedule，可以根据充电需求和策略来规划和控制充电过程。
   * 		例如，可以根据电网的负载情况和用户的需求，在非高峰时段设置较高的充电功率以加快充电速度，在高峰时段限制充电功率以平衡电网负荷。
   *
   * 		startPeriod :
   * 充电计划周期的起始时间点。它指定了充电速率设置的起始时间，通常以秒为单位。充电开始后，每个周期的起始时间将与充电桩的当前时间对齐。
   * 		limit :
   * 充电速率的限制。它指定了该周期内的最大充电速率，通常以充电功率单位（如kW、A）为基础。
   * 		numberPhases :
   * 充电周期的相数。它指定了充电桩在该周期内使用的相数，通常为单相（1）或三相（3）。
   */
  chargingSchedulePeriod: ChargingSchedulePeriod[]
  /**
   * Duration 充电计划的持续时间，以秒为单位。 选填
   * 它指定了充电计划的总体时长，即从开始时间到结束时间。
   * 例如: 86400 表示天
   */
  duration: number
  /** MinChargingRate 最小的充电速率 选填 */
  minChargingRate: number
  /**
   * StartSchedule 充电计划的开始时间，用于指定充电计划的起始时间点。选填
   * 它是相对于当前时间设定的，通常用于即时或未来的充电计划
   */
  startSchedule: string
}
export interface ChargingProfile {
  /** ChargingProfileId 充电配置ID 必填项 */
  chargingProfileId: number
  /**
   * ChargingProfileKind 充电配置类型 必填项
   * Absolute
   * 绝对充电配置文件。是指在特定的时间段内，充电设备应该按照预定的充电功率进行充电。这意味着充电设备会在规定的时间段内以特定的功率进行充电，无论电动汽车的需求如何。
   * Recurring
   * 重复充电配置文件。是指在特定的时间段内，充电设备应该按照预定的充电功率进行充电，并且可以在多个时间段内重复。这种配置文件适用于在每天或每周相同的时间段内充电的场景。
   * Relative
   * 相对充电配置文件。是指在特定的时间段内，充电设备应根据电动汽车的需求来动态调整充电功率。这意味着充电设备会根据电动汽车的需求，在规定的时间段内动态调整充电功率。
   */
  chargingProfileKind: string
  /**
   * ChargingProfilePurpose 充电配置目的 必填项
   * ChargePointMaxProfile
   * 表示充电站最大功率充电档案。这种充电档案用于定义充电站所能提供的最大充电功率。充电档案中的充电速率限制将被应用于所有充电桩，以确保充电站总的功率不超过所定义的最大值。
   * TxDefaultProfile
   * 表示充电桩默认充电档案。该档案用于定义充电桩的默认充电行为，例如默认的充电功率、充电时间等。当用户未指定特定的充电档案时，将使用该默认档案。
   * TxProfile
   * 表示充电桩特定充电档案。该档案用于定义特定充电桩的充电行为，例如特定的充电功率、充电时间等。当用户指定了特定的充电档案时，将使用该档案而不是默认档案。
   */
  chargingProfilePurpose: string
  /** ChargingSchedule 充电计划  必填项 */
  chargingSchedule: ChargingSchedule | undefined
  /**
   * RecurrencyKind 充电配置重复类型
   * Daily:
   * 表示按日重复。按日重复意味着事件将每天重复发生，可以指定重复事件的开始时间和结束时间。
   * Weekly:
   * 表示按周重复。按周重复意味着事件将每周重复发生，可以指定重复事件的开始时间和结束时间以及重复事件的重复日期（星期几）。
   * Monthly:
   * 表示按月重复。按月重复意味着事件将每月重复发生，可以指定重复事件的开始时间和结束时间以及重复事件的重复日期（每月的哪一天）。
   */
  recurrencyKind: string
  /**
   * StackLevel profile等级,
   * 必需。配置文件层次结构堆栈中的值确定级别。较高的值优于较低的值。最低级别为
   * 0。 设备优先使用等级高的profile, 默认是0
   */
  stackLevel: number
  /**
   * TransactionId 充电中修改订单事物交易。选填
   * 仅当"充电配置文件用途"设置为"Tx 配置文件"时才有效。事务 Id
   * 可用于将配置文件与特定事务进行匹配。
   */
  transactionId: number
  /** ValidFrom 生效开始时间 选填 */
  validFrom: string
  /** ValidTo 生效结束时间 选填 */
  validTo: string
}
export interface Card {
  /** 卡ID */
  id: number
  /** 卡号 */
  cardNo: string
  /** 运营商ID */
  operatorID: number
  /** 站点ID */
  stationID: number
  /** 用户ID */
  userID: number
  /** 是否禁用 */
  ban: boolean
  /** 卡类型 (3,4,5) */
  cardType: IdType
  /** 更新时间 */
  updatedAt: number
  /** 创建时间 */
  createdAt: number
  /** 运营商Name */
  operatorName: string
  /** 站点Name */
  stationName: string
  /** 设备ID */
  evseID: number
  /** 设备SN */
  sn: string
  /** 用户Name */
  userName: number
  /** 卡来源 */
  source: CardSource
}

export enum UploadFileState {
  UFS_UNKNOWN = 0,
  UFS_Requesting = 10,
  UFS_RequesFailed = 20,
  UFS_RequesSuccess = 30,
  UFS_Uploading = 50,
  UFS_UploadFailed = 90,
  UFS_Uploaded = 100,
  UNRECOGNIZED = -1,
}

export enum ChargingScheduleAlgorithm {
  /** CSA_DISABLED - 不支持 */
  CSA_DISABLED = 0,
  /** CAS_FCFS - 先到现充, First Come First Serve */
  CAS_FCFS = 1,
  /** CAS_AVG - 平均值 */
  CAS_AVG = 2,
  UNRECOGNIZED = -1,
}

/** 道闸类型 */
export enum BarrierGateType {
  BGT_UNKNOWN = 0,
  /** BGT_JS - 捷顺道闸 */
  BGT_JS = 1,
  /** BGT_LTY - 路通云道闸 */
  BGT_LTY = 2,
  UNRECOGNIZED = -1,
}

export enum BarrierGateCouponType {
  HEJT_UNKNOWN = 0,
  /** HEJT_AMOUNT - 金额减免 单位 元 */
  HEJT_AMOUNT = 1,
  /** HEJT_TIME - 时间减免 单位 小时 */
  HEJT_TIME = 2,
  /** HEJT_FREE - 全免 */
  HEJT_FREE = 3,
  UNRECOGNIZED = -1,
}
export interface CmsOperator {
  /** 运营商ID */
  id: number
  /** 运营商名称 */
  name: string
  /** 运营商所属国家 */
  country: Country
  /** 运营商货币 */
  currency: Currency
  /** 公司信息 */
  company: string
  /** 运营状态 */
  businessState: BusinessState
  /** 备注 */
  remark: string
  /** 运营商负责人 */
  operatorPrincipal: string
  /** 负责人电话 */
  principalPhone: string
  /** 负责人邮箱 */
  principalEmail: string
  /** 区域编码 */
  areaCode: string
  /** 地址 */
  address: string
  /** 经度 */
  lng: string
  /** 纬度 */
  lat: string
  /** 是否禁用 */
  banned: boolean
  /** 注册时间 */
  createdAt: number
  /** 是否自运营 */
  isSelfOperating: boolean
}
export interface ChargingTimeTariff {
  /** 分段费率起始功率，分辨率W */
  powerStart: number
  /** 分段费率结束功率，分辨率W */
  powerEnd: number
  /** 电费，每度电多少钱， 单位 元 最多精确到4位小数 */
  price: number
  /** 服务费， 按小时多少钱，单位 元 最多精确到4位小数。 */
  servicePrice: number
  /** 免费充电时间 */
  freeTime: number
}
export interface GetPriceingListReq {
  pageReq?: PageReq | undefined
  id?: number
  operatorId?: number
  name?: string
  stationId?: number
}
export enum GroupType {
  GT_UNKNOWN = 0,
  /** GT_Pricing - 计费组 - 只使用计费策略 */
  GT_Pricing = 1,
  /** GT_Enterprise - 企业组 - 使用集团钱包 */
  GT_Enterprise = 2,
  UNRECOGNIZED = -1,
}

export interface Group {
  id: number
  /** 运营商ID */
  operatorId: number
  /** 运营商名称 */
  operatorName: string
  /** 设备运营商ID */
  evseOperatorId: number
  /** 设备运营商名称 */
  evseOperatorName: string
  /** 组类型 */
  type: GroupType
  name: string
  phone: string
  enable: boolean
  /** true 设备运营商 所有站点通用，false 需要指定授权站点 */
  global: boolean
  createdAt: number
  updatedAt: number
  /** 余额 */
  balance: number
  /** 折扣信息 */
  elecPriceDiscount: number
  /** 服务费折扣 [0 -1] */
  servicePriceDiscount: number
  /** 计费类型 */
  priceingType: PricingDescountInfoType
  /** 固定金额信息 */
  sharpElecAmount: number
  /** 尖 服务费 */
  sharpServiceAmount: number
  /** 峰 电费费 */
  peakElecAmount: number
  /** 峰 服务费 */
  peakServiceAmount: number
  /** 平 电费费 */
  flatElecAmount: number
  /** 平 服务费 */
  flatServiceAmount: number
  /** 谷 电费费 */
  valleyElecAmount: number
  /** 谷 服务费 */
  valleyServiceAmount: number
  /** 谷 电费费 */
  deepValleyElecAmount: number
  /** 谷 服务费 */
  deepValleyServiceAmount: number
}

export interface UpsertGroupReq {
  /** 修改的时候必传. */
  id: number
  /** 运营商ID */
  evseOperatorId: number
  /** 组类型 */
  type: GroupType
  name: string
  phone: string
  /** true 设备运营商 所有站点通用，false 需要指定授权站点 */
  global: FieldEnable
  /** 是否启用, 更新时，空值不做更新 */
  enable: FieldEnable
  /** 按比率 */
  elecPriceDiscount: number
  /** 服务费折扣 */
  servicePriceDiscount: number
  /** 计费类型 */
  priceingType: PricingDescountInfoType
  /** 固定金额信息 */
  sharpElecAmount: number
  /** 尖 服务费 */
  sharpServiceAmount: number
  /** 峰 电费费 */
  peakElecAmount: number
  /** 峰 服务费 */
  peakServiceAmount: number
  /** 平 电费费 */
  flatElecAmount: number
  /** 平 服务费 */
  flatServiceAmount: number
  /** 谷 电费费 */
  valleyElecAmount: number
  /** 谷 服务费 */
  valleyServiceAmount: number
}

export interface GroupMember {
  id: number
  /** 运营商ID */
  operatorId: number
  /** 运营商名称 */
  operatorName: string
  ado: ADOType
  adoid: number
  adoName: string
  enable: boolean | number
  createdAt: number
  updatedAt: number
}

export interface UpsertGroupMemberReq {
  /** 更新时必传， 添加时不传。 主要是禁用更新 */
  id: number
  /** 集团iD, 添加时必传 */
  groupId: number
  ado: ADOType
  adoid: number
  /** 手机号， 卡号， vin */
  adoFlag: string
  /** 是否启用, 更新时，空值不做更新 */
  enable: FieldEnable
}

export interface ADO {
  adoType: ADOType
  id: number
  name: string
  /**
   * 扩展信息
   * isMaster 是否主从, true: 主, false 从
   * email 邮件
   * phone 电话
   * card 卡号
   * vin 车架号
   */
  ex: { [key: string]: string }
}

export interface GroupStation {
  id: number
  /** 设备运营商ID */
  evseOperatorId: number
  /** 设备运营商名称 */
  evseOperatorName: string
  stationId: number
  stationName: string
  enable: boolean
  createdAt: number
  updatedAt: number
}

/** 设备二维码， 管理后台下载时使用 */
export interface EvseQrcode {
  /** 设备ID */
  evseId: number
  /** 设备编号 */
  sn: string
  /** 设备别名 - 用户自定义 */
  evseAlias: string
  /** 枪头编号 */
  cno: number
  /** 枪头别名 - 用户自定义 */
  connectorAlias: string
  /** 枪头编号 = 0 表示设备二维码, > 0 表示枪头二维码。 根据cno，显示alias */
  qrcode: string
}
export enum PricingDescountInfoType {
  /** PDIT_RATIO - 按比例计算 */
  PDIT_RATIO = 0,
  /** PDIT_FIXED - 按固定金额计算 */
  PDIT_FIXED = 1,
}

export interface StationTopInfo {
  /** 站点名称 */
  stationName: string
  /** 总电量 度 */
  totalElec: number
}

export interface StationMapInfo {
  stationName: string
  /** 经度 */
  lat: number
  /** 纬度 */
  lng: number
  /** 设备数量 */
  evseNum: number
}

export enum StationNature {
  /** SN_EVSE - 仅充电 */
  SN_EVSE = 1,
  /** SN_ESS - 储充 */
  SN_ESS = 2,
  /** SN_PVES - 光伏储充 */
  SN_PVES = 4,
}

export enum EssDeviceType {
  /** EDT_UNKNOWN - 未知设备类型 */
  EDT_UNKNOWN = 0,
  /** EDT_PV - 光伏逆变器 */
  EDT_PV = 1,
  /** EDT_ES - 储能逆变器(电池储能) */
  EDT_ES = 2,
  /** EDT_HYBRID - 混合逆变器(光储一体化) */
  EDT_HYBRID = 3,
  /** EDT_MICRO - 微电网逆变器 */
  EDT_MICRO = 4,
  /** EDT_GRID - 并网逆变器 */
  EDT_GRID = 5,
  /** EDT_OFFGRID - 离网逆变器 */
  EDT_OFFGRID = 6,
  UNRECOGNIZED = -1,
}

export enum EssRankFilter {
  /** ERF_Default - 默认排序 */
  ERF_Default = 0,
  /** ERF_ChargeEnergy - 根据充电量排序 */
  ERF_ChargeEnergy = 1,
  /** ERF_DischargeEnergy - 根据放电量排序 */
  ERF_DischargeEnergy = 2,
  /** ERF_GenEnergy - 根据发电量排序 */
  ERF_GenEnergy = 3,
  /** ERF_LoadPower - 根据负载功率排序 */
  ERF_LoadPower = 4,
  /** ERF_SelfSufficiencyRate - 根据自给自足率排序 */
  ERF_SelfSufficiencyRate = 5,
  UNRECOGNIZED = -1,
}

export interface EssStationRank {
  /** 站点ID */
  stationId: number
  /** 站点名称 */
  stationName: string
  /** 发电电量(kWh) */
  genEnergy: number
  /** 充电电量(kWh) */
  chargeEnergy: number
  /** 放电电量(kWh) */
  dischargeEnergy: number
  /** 负载功率(Kw) */
  loadPower: number
  /** 自给自足率(%) */
  selfSufficiencyRate: number
}

export interface EssEnergyFlow {
  /** 电池容量(kW) */
  batteryCapacity: number
  /** 电池剩余电量(%) */
  batterySOC: number
  /** 电池功率(kW) */
  batteryPower: number
  /** 电网状态(-1：异常/未开通 0：空闲 1：运行中) */
  gridStatus: number
  /** 电网功率(kW) */
  gridPower: number
  /** 光伏板状态(-1：故障 0：空闲 1：发电中) */
  pvStatus: number
  /** 光伏功率(kW) */
  PvPower: number
  /** PV光伏板额定功率(kWp) */
  pvCapacity: number
  /** 负载功率(kW) */
  loadPower: number
  /** 光伏流向(0：静止 1：发电中) */
  pvDirection: number
  /** 电网流向(-1：馈电 0：静止 1：供电) */
  gridDirection: number
  /** 电池流向(-1：充电 0：静止 1：放电) */
  batteryDirection: number
  /** 负载流向(0：静止 1：用电中) */
  loadDirection: number
  /** 是否有电池 */
  hasBattery: boolean
  /** 是否有光伏 */
  hasPv: boolean
  /** 是否有电网 */
  hasGrid: boolean
  /** 是否有负载 */
  hasLoad: boolean
}

export interface GetEssStationStatusReply {
  /** 运营率 */
  operatingRate: number
  /** 站点总数 */
  stationCount: number
  /** 告警站点数 */
  alarmCount: number
  /** 监控站点数 */
  monitorCount: number
  /** 未监控站点数 */
  otherCount: number
}

export interface GetEssAlarmStatusReply {
  /** 总告警次数 */
  totalCount: number
  /** 紧急告警数 */
  crashCount: number
  /** 重要告警次数 */
  importantCount: number
  /** 一般告警次数 */
  minorCount: number
}

/** 并网类型(全额馈网、自发自用、无馈网、离网) */
export enum EssGridType {
  /** EGT_Unknown - 未知并网方式 */
  EGT_Unknown = 0,
  /** EGT_FeedbackAll - 全额馈网 */
  EGT_FeedbackAll = 1,
  /** EGT_SelfSufficiency - 自发自用(部分馈网) */
  EGT_SelfSufficiency = 2,
  /** EGT_NoFeedback - 无馈网 */
  EGT_NoFeedback = 3,
  /** EGT_OffGrid - 离网 */
  EGT_OffGrid = 4,
}

// 救援工单状态
export enum RescueOrderState {
  ROS_Unknown = 0, // 未知
  ROS_WaitPay = 1, // 工单已下单,等待支付
  ROS_Pending = 2, // 工单等待处理
  ROS_Processing = 3, // 工单已派人处理
  ROS_Done = 4, // 工单已完成
  ROS_Fail = 5, // 工单支付失败，订单作废
  ROS_Refund = 6, // 工单已退款
}

// 道路救援类型
export enum RescueType {
  RT_Unknown = 0, // 未知
  RT_JumpStart = 1, // 搭电
  RT_TireChange = 2, // 换胎
  RT_Towing = 3, // 拖车
  RT_EmergencyExtraction = 4, // 紧急脱困
  RT_DeliveryElectricity = 5, // 送电上门
}

//  投资合作类型
export enum CooperType {
  CT_Unknown = 0, // 未知
  CT_Investment = 1, // 投资
  CT_Cooperation = 2, // 场地合作
  CT_ToJoin = 3, // 加盟
}

//  投资合作申请状态
export enum CooperState {
  CS_Unknown = 0,  // 未知
  CS_Pending = 1,  // 等待处理
  CS_Done    = 2,  // 已处理完
}

export enum ParkingLockState {
  /** PLS_UNKNOWN - 未知 */
  PLS_UNKNOWN = 0,
  /** PLS_RISE - 已上升 */
  PLS_RISE = 1,
  /** PLS_RISING - 上升中 */
  PLS_RISING = 2,
  /** PLS_FALL - 已下降 */
  PLS_FALL = 3,
  /** PLS_FALLING - 下降中 */
  PLS_FALLING = 4,
  /** PLS_STOPPED - 下降、上升中停止 */
  PLS_STOPPED = 5,
  UNRECOGNIZED = -1,
}


export enum ParkingVehicleState {
  /** PVS_UNKNOWN - 未知 */
  PVS_UNKNOWN = 0,
  /** PVS_ALREADY_PARKED - 有车 */
  PVS_ALREADY_PARKED = 1,
  /** PVS_NOT_PARKED - 未停车 */
  PVS_NOT_PARKED = 2,
  UNRECOGNIZED = -1,
  CS_Unknown = 0, // 未知
  CS_Pending = 1, // 等待处理
  CS_Done = 2, // 已处理完
}

/** 计费策略版本信息(用于定时发布计费策略) */
export interface ClockingPriceingVer {
  /** 版本id */
  id: number
  /** 计价策略id */
  priceingId: number
  /** 运营商id */
  operatorId: number
  /** 策略使用车辆 */
  vt: UseVehicleType
  /** 按电量计费 */
  elecTariffs: ElecTariff[]
  /** 按照时间功率计费 */
  chargingTimeTariffs: ChargingTimeTariff[]
  /** 占桩费 */
  occupyTariff: OccupyTariff | undefined
  /** 货币 */
  currency: Currency
  /** 策略版本创建时间 */
  createdAt: number
  /** 最小计费单位, 元 最多精确到4位小数。 */
  unitPrice: number
  /** 免费充电时间 分钟 */
  freeTime: number
  /** 发布时间(发布时间只精确到小时 格式："2025-07-30 14:00:00") */
  publishTime: string
}
